import React, { useState, useEffect,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import { Switch, useHistory, useLocation } from 'react-router-dom';
import { fncUndoCheckInPassengerApi, fncLoadFlightManifestDataForBoarding, fncGetTripStatus, fncBoardPassengers, fncUnBoardPassengers, fncCallSeatMapApi, fncSeatIdentificationApi, fncAssignPassengerSeats, fncAutoAssignPassengerSeats, fncUnAssignPassengerSeats, fncUnBlockSeat, fncBlockSeat, fncGetBoardingPassApi } from '../Utility/ApiCall.js';
import { flightManifestBoardingCredential, flightTripBoardingCredential, assistQueueCredential, seatIdentificationCredential, setflightLegKeyCredential,FocusToSubheaderOfSeatmanagementCredential, moduleAndLoginDivDisabled } from '../ReduxState';
import { mapToProp, searchPageIconsMapping, getSegmentsDetail, getIconForPassenger, fncSeatGroupSelection, boardingModule, seatBlockSSRS, shortcutKeyForBoardingsPage, shortcutKeysBoarding, fncCheckIfTokenIsExpired, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'react-bootstrap';
import * as moment from 'moment';
import '../Scss/_boarding.scss';
// import '../Scss/_app.scss';
import '../Scss/_ui-elements.scss';
import FocusLock from "react-focus-lock";

function SeatManagement() {
    const subHeaderRef = useRef(null);
    const [shiftUpCount, setShiftUpCount] = useState(2);
    const okbutton = useRef(null);
    const okbutton1 = useRef(null);
    const PaxNotSelected = useRef(null);
    const allselectref = useRef(null);
    const blockinputref = useRef(null);
    const inputElementForSeat = useRef([]);
    const seatmanagementsortref = useRef([]);
    const [activeleftChildIndex, setActiveleftChildIndex] = useState(0); // Track the active left child  index
    const unAssignref = useRef([]);
    const [focusedDiv, setFocusedDiv] = useState('leftmid'); // 'left' or 'right' or "leftup"
    const [unlockBLOCKSEAT, setunlockBLOCKSEAT] = useState(false); // 'left' or 'right' or "leftup"
    const [activeIndex, setActiveIndex] = useState(0); // Track the active right child  index
    const rightSeatsDivRef = useRef([]); // Ref for the right seats div
    const [leftupdiv, setleftupdiv] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [triggerModal, settriggerModal] = useState(false);
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const flightTripStatus = useSelector(state => state.flightSearch.flightTripBoarding);
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const seatMapTask = useSelector(state => state.flightSearch.seatmapTask);
    const isFocusToSubheaderOfSeatmanagement = useSelector(state => state.login.isFocusToSubheaderOfSeatmanagement);
    const IsModulAndLoginDivDisabled = useSelector(state =>state.login.IsModulAndLoginDivDisabled);
    const [passengerList, setPassengerList] = useState(flightManifest.passengerList.length ? flightManifest.passengerList : []);
    const seatIdentificationData = useSelector(state => state.seat.SeatIdentification);
    const aisle = useSelector(state => state.flightSearch.seatPreferenceAisle);
    const window = useSelector(state => state.flightSearch.seatPreferenceWindow);
    const [checkedStandBy, setcheckedStandBy] = useState(false);
    const [boarded, setboarded] = useState(false);
    const [totalcheckedIn, settotalcheckedIn] = useState(false);
    const [noseat, setnoseat] = useState(false);
    const [withExtraSeat, setwithExtraSeat] = useState(false);
    const [allCheckedInWithoutSeat, setallCheckedInWithoutSeat] = useState(false);
    const [filterName, setfilterName] = useState('');
    // const [showFilterMenu, setshowFiilterMenu] = useState(false);
    const [recordlocator, setRecordlocator] = useState('');
    const [seatForBlockSection, setSeatForBlockSection] = useState('');
    const [st_AirlineHeader, setAirlineHeader] = useState([]);
    const [st_countOfRowsFormed, setcountOfRowsFormed] = useState([]);
    const [selectedRow, setSelectedRow] = useState(-1);
    const [printBP, setPrintBP] = useState(true);
    const [autoAssign, setAutoAssign] = useState(true);
    const [unAssign, setUnAssign] = useState(true);
    const [release, setrelease] = useState(true);
    const [block, setblock] = useState(true);
    // const [inoperable, setinoperable] = useState(true);
    const [showErrorPopup, setshowErrorPopup] = useState(false);
    const [selectAllPassengers, setselectAllPassengers] = useState(false);
    const [showPaxNotSelectedError, setshowPaxNotSelectedError] = useState(false);
    const [showSSRSeatNotAvailableErrorPopup, setShowSSRSeatNotAvailableErrorPopup] = useState(false);
    const [userInputSeat, setSeatFromUserInput] = useState('');
    const [st_UserSeatDetails, setUserSeatDetails] = useState([{
        "PassengerName": "",
        "PassengerGender": "",
        "WithORwithoutINFT": "",
        "SEATDETAIL": "",
        "Amount": "",
        "AisleOrWindow": "",
        "SeatClass": "",
        "PassengerInfo": "",
        "PassengerTypeCode": "",
        "PassengerKey": "",
        "PassengerWheelChair": "",
        "unitkey": "",
        "SelectedPassenger": false
    }])
    const [disablelockTable, setdisablelockTable] = useState(false);
    const handleSSRSeatNotAvailableErrorPopup = () => setShowSSRSeatNotAvailableErrorPopup(false);
    const handleCloseshowErrorPopup = () => setshowErrorPopup(false);
    const handleshowPaxNotSelectedError = () => setshowPaxNotSelectedError(false);
    const notify = (e, close = 5000) =>
    toast.error(e, {
        position: "top-right",
        autoClose: close,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    useEffect(() => {
        if ( inputElementForSeat.current[activeleftChildIndex]) {
               inputElementForSeat.current[activeleftChildIndex].focus();}
     },[]);

    useEffect(() => {
        // if (flightManifest) {
            const passengers = [...passengerList];
            const selectedPassengers = passengers.filter(pax => pax.isSelectedForSeatAssign);
            // console.log('selectedPassengers', selectedPassengers);
            if (selectedPassengers.length) {
                if (selectedPassengers.length === 1) {
    
                    // console.log('seat-----', getSegmentsDetail(flightManifest.market,'seat', selectedPassengers[0]));
                    // console.log('status-----', getSegmentsDetail(flightManifest.market,'liftStatus', selectedPassengers[0]));
    
                    if (getSegmentsDetail(flightManifest.market,'liftStatus', selectedPassengers[0]) === 0) {
                        setPrintBP(true);
                        if (getSegmentsDetail(flightManifest.market,'seat', selectedPassengers[0])) {
                            setUnAssign(false);
                        } else {
                            setAutoAssign(false);
                            setUnAssign(true);
                        }
                    }
                    
                    if ([1,2].includes(getSegmentsDetail(flightManifest.market,'liftStatus', selectedPassengers[0]))) {
                        setPrintBP(false);
                        if (getSegmentsDetail(flightManifest.market,'seat', selectedPassengers[0])) {
                            setUnAssign(false);
                            setPrintBP(false);
                        } else {
                            setAutoAssign(false);
                            setUnAssign(true);
                        }
                    }
                    
                } else {
                    if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 0)) {
                        setPrintBP(true);
                        if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax))) {
                            setUnAssign(false);
                            setAutoAssign(true);
                        }
                        else if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax)) === null
                        || selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax)) === '') {
                            setAutoAssign(false);
                            setUnAssign(true);
                        }
                        // else {
                        //     setPrintBP(true);
                        //     setAutoAssign(true);
                        //     setUnAssign(true);
                        // }
                    }
    
                    else if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 1)
                    || selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'liftStatus', pax) === 2)) {
                        setPrintBP(false);
                        if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax))) {
                            setUnAssign(false);
                            // setPrintBP(false);
                        } else if (selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax)) === null
                        || selectedPassengers.every(pax => getSegmentsDetail(flightManifest.market,'seat', pax)) === '') {
                            setAutoAssign(false);
                        }
                        // else {
                        //     // setAutoAssign(false);
                        //     setUnAssign(true);
                        // }
                    } else {
                        setPrintBP(true);
                        setAutoAssign(true);
                        setUnAssign(true);
                    }
                }
            }
            else {
                // if (!selectAllPassenger) {
                    setPrintBP(true);
                    setAutoAssign(true);
                    setUnAssign(true);
                // }
            }
        // }
        
    });

    useEffect(() => {
        if (selectedLeg && flightManifest) {
            document.addEventListener("keydown", shortcutKeyHandler);
        }

        // cleanup this listener
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    }, [selectedLeg, flightManifest]);

    const shortcutKeyHandler = (e) => { 
        // debugger
        if (e.key && shortcutKeysBoarding.includes(e.key)) {
            const path = shortcutKeyForBoardingsPage(location.pathname,e);
            if (path) {
                history.push('/' + path);    
            } 
        }
    }

    useEffect(() => {
        const requestParam = [];
        requestParam.push({
            legkey: selectedLeg
        });
        fncSeatIdentificationApi(requestParam)
        .then((returnVal) => {

          document.getElementById("showAndHideSpinner").style.display = "block";
          if (returnVal.status == "401" && returnVal.data == "") {
            document.getElementById("showAndHideSpinner").style.display = "none";
            // notify(returnVal.statusText);
            settriggerModal(true);
          } else {
            if (!returnVal.data.isError) {
              // console.log('return val for seat identification, ', returnVal.data);
              dispatch(seatIdentificationCredential(
                {
                  type: "",
                  SeatIdentification: returnVal.data.flightmanifest
                }
              ));
              document.getElementById("showAndHideSpinner").style.display = "none";
            } else {
              document.getElementById("showAndHideSpinner").style.display = "none";
              if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                settriggerModal(true);
                } else {
                        notify(returnVal.data.errorDetail.errorMessage);
                }
            }
          }
        })
        .catch(err => console.log("Axios err: ", err));
    }, []);

    useEffect(() => {
        callSeatMap();
    }, []);

    const callSeatMap = async (passengerList) => {
        const flightNo = flightManifest.market.identifier.identifier;
        const { segments } = flightManifest
        && flightManifest.passengerList.length
        && flightManifest.passengerList[0].services[0];
        debugger
        const currentSegment = segments && segments.filter(s => s.market.identifier.identifier === flightNo)[0];
        if (currentSegment) {
            fncCallSeatMapApi(currentSegment.segmentKey, boardingModule)
            .then((returnVal) => {

                // debugger;
                document.getElementById("showAndHideSpinner").style.display = "block";
                // if ((returnVal.status == "401" && returnVal.data == "") || (returnVal.status == "500"))
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {

                        var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments;
                        // setSeatMapApiData(returnVal.data);

                        var compartmentsLength = returnVal.data.seatMapResponse.seatMap.decks[0].compartments.length;
                        let countOfRowsFormedAftrAddingFalseSets = [];
                        // For multiple compartments
                        if (compartmentsLength > 1) {
                            const result = [];
                            const map = new Map();
                            for (const item of seats.Compartments[1].Seats) {
                                if (item.SeatDesignator.length == 2) {
                                    var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2);
                                    if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2))) {
                                        map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2), true);    // set any value to Map
                                        result.push({
                                            SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 2),
                                            X: item.X
                                        });
                                    }
                                }
                                else {
                                    var test = item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3);
                                    if (!map.has(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3))) {
                                        map.set(item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3), true);    // set any value to Map
                                        result.push({
                                            SeatDesignator: item.SeatDesignator.substring(item.SeatDesignator.length - 1, 3),
                                            X: item.X
                                        });
                                    }
                                }

                            }
                            var arrayWithMargin = [];
                            var mar = 0;
                            var marginAllowed = 0;
                            for (var i = 0; i < result.length; i++) {
                                if (i == 0) {
                                    if (result[i].SeatDesignator != "") {
                                        arrayWithMargin[i] = {
                                            SeatDesignator: result[i].SeatDesignator,
                                            X: result[i].X,
                                            Margin: 0,
                                        }
                                    }

                                }
                                else {
                                    if (i == 1) {
                                        mar = result[i].X - result[i - 1].X;
                                    }
                                    var diff = result[i].X - result[i - 1].X;
                                    if (diff > mar) {
                                        marginAllowed = 1;
                                    }
                                    else {
                                        marginAllowed = 0;
                                    }
                                    if (result[i].SeatDesignator != "") {
                                        arrayWithMargin[i] = {
                                            SeatDesignator: result[i].SeatDesignator,
                                            X: result[i].X,
                                            Margin: marginAllowed,
                                        }
                                    }


                                }
                            }


                            var marSeats = 0;
                            var marginAllowedSeats = 0;
                            var countOfRowsFormed = [];

                            var counter = 0;
                            for (var k = 0; k < seats.Compartments.length; k++) {
                                var compartmentSeats = seats.Compartments[k].Seats;
                                const maxValueOfY = Math.max(...compartmentSeats.map(o => o.SeatRow), 0);
                                const minValueOfY = Math.min(...compartmentSeats.map(o => o.SeatRow), 0);


                                for (var j = 0; j < maxValueOfY; j++) {
                                    var arrayWithMarginSeats = [];
                                    var count = 0;


                                    for (var i = 0; i < compartmentSeats.length; i++) {
                                        if ((j + 1) === compartmentSeats[i].SeatRow) {

                                            if (i === 0) {

                                                // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));

                                                arrayWithMarginSeats[count] = {
                                                    SeatDesignator: compartmentSeats[i].SeatDesignator,
                                                    X: compartmentSeats[i].X,
                                                    Margin: 0,
                                                    SeatRow: compartmentSeats[i].SeatRow,
                                                    Status: compartmentSeats[i].Status
                                                }
                                            }
                                            else {
                                                if (i === 1) {
                                                    marSeats = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                                                }
                                                var diff = compartmentSeats[i].X - compartmentSeats[i - 1].X;
                                                if (diff > marSeats) {
                                                    marginAllowedSeats = 1;
                                                }
                                                else {
                                                    marginAllowedSeats = 0;
                                                }

                                                // var obj = arrayWithMargin.find(o => o.SeatDesignator === compartmentSeats[i].SeatDesignator.substring(compartmentSeats[i].SeatDesignator.length-1,2));

                                                arrayWithMarginSeats[count] = {
                                                    SeatDesignator: compartmentSeats[i].SeatDesignator,
                                                    X: compartmentSeats[i].X,
                                                    Margin: marginAllowedSeats,
                                                    SeatRow: compartmentSeats[i].SeatRow,
                                                    Status: compartmentSeats[i].Status
                                                }
                                            }
                                            count = count + 1;
                                        }
                                    }
                                    if (arrayWithMarginSeats.length != 0) {
                                        countOfRowsFormed[counter] = {
                                            id: counter,
                                            dataToBind: arrayWithMarginSeats
                                        };
                                        counter = counter + 1;
                                    }
                                }
                            }

                            // arrayWithMargin


                            //------------------------------------------------------------------ new Implementations-------------------------------------


                            for (var i = 0; i < countOfRowsFormed.length; i++) {
                                var arrayWithMarginAftrAddingFalseSets = [];
                                var fcount = 0;
                                var seatCount = "";
                                for (var j = 0; j < arrayWithMargin.length; j++) {
                                    var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);

                                    if (obj != undefined) {
                                        seatCount = obj.SeatRow;
                                        arrayWithMarginAftrAddingFalseSets[fcount] = {
                                            SeatDesignator: obj.SeatDesignator,
                                            X: obj.X,
                                            Margin: obj.Margin,
                                            SeatRow: obj.SeatRow,
                                            Status: obj.Status
                                        }
                                    }
                                    else {
                                        arrayWithMarginAftrAddingFalseSets[fcount] = {
                                            SeatDesignator: "false",
                                            X: 0,
                                            Margin: 0,
                                            SeatRow: '',
                                            Status: 0
                                        }
                                    }
                                    fcount = fcount + 1;
                                }
                                countOfRowsFormedAftrAddingFalseSets[i] = {
                                    id: seatCount,
                                    dataToBind: arrayWithMarginAftrAddingFalseSets
                                };

                            }

                            this.setState({
                                // st_countOfRowsFormed: countOfRowsFormedAftrAddingFalseSets,
                                st_AirlineHeader: arrayWithMargin
                            })
                        }
                        else {
                            // For single compartment
                            //   const maxValueOfY = Math.max(...returnVal.data.compartments[0].units.map(o => o.designator), 0); 
                            //   const maxValueOfY = Math.max(...seats.Compartments[0].Seats.map(o => o.SeatRow), 0);   


                            const maxValueOfY = 20;
                            const result = [];
                            const uniqueROWS = [];
                            const map = new Map();
                            // changes on 27 August 2020
                            for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                                if (item.unitKey != null) {
                                    if (item.designator.length == 2) {
                                        var test = item.designator.substring(item.designator.length - 1, 2);
                                        if (!map.has(item.designator.substring(item.designator.length - 1, 2))) {
                                            map.set(item.designator.substring(item.designator.length - 1, 2), true);    // set any value to Map
                                            result.push({
                                                SeatDesignator: item.designator.substring(item.designator.length - 1, 2),
                                                X: item.x
                                            });
                                        }
                                    }
                                    else {
                                        var test = item.designator.substring(item.designator.length - 1, 3);
                                        if (!map.has(item.designator.substring(item.designator.length - 1, 3))) {
                                            map.set(item.designator.substring(item.designator.length - 1, 3), true);    // set any value to Map
                                            result.push({
                                                SeatDesignator: item.designator.substring(item.designator.length - 1, 3),
                                                X: item.x
                                            });
                                        }
                                    }
                                }
                            }

                            result.sort((a, b) => a.SeatDesignator > b.SeatDesignator ? 1 : -1);

                            for (const item of returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units) {
                                if (item.unitKey != null) {

                                    var test = item.designator.replace(/[^0-9]/g, '');

                                    if (!map.has(parseInt(test))) {
                                        map.set(parseInt(test), true);    // set any value to Map
                                        uniqueROWS.push(parseInt(test));
                                    }

                                }
                            }



                            var arrayWithMargin = [];
                            var mar = 0;
                            var marginAllowed = 0;
                            for (var i = 0; i < result.length; i++)  // changed on 27 august 2020
                            {
                                if (i == 0) {
                                    if (result[i].SeatDesignator != "") {
                                        arrayWithMargin[i] = {
                                            SeatDesignator: result[i].SeatDesignator,
                                            X: result[i].X,
                                            Margin: 0,
                                        }
                                    }

                                }
                                else {
                                    if (i == 1) {
                                        mar = result[i].X - result[i - 1].X;
                                    }
                                    var diff = result[i].X - result[i - 1].X;
                                    if (diff > mar) {
                                        marginAllowed = 1;
                                    }
                                    else {
                                        marginAllowed = 0;
                                    }
                                    if (result[i].SeatDesignator != "") {
                                        arrayWithMargin[i] = {
                                            SeatDesignator: result[i].SeatDesignator,
                                            X: result[i].X,
                                            Margin: marginAllowed,
                                        }
                                    }
                                }
                            }
                            setAirlineHeader(arrayWithMargin);
                            // setSegmentKeyForCurrentSeatmap(segmentKey);
                            // debugger;

                            var marSeats = 0;
                            var marSeatsY = 0;
                            var marginAllowedSeats = 0;
                            var marginAllowedSeatsY = 0;
                            var seats = returnVal.data.seatMapResponse.seatMap.decks[0].compartments[0].units;
                            var countOfRowsFormed = [];
                            for (var j = 0; j < uniqueROWS.length; j++) {
                                var arrayWithMarginSeats = [];
                                var count = 0;
                                var isEntered = false;
                                var comparewithlast = 0;
                                for (var i = 0; i < seats.length; i++) {

                                    if (seats[i].unitKey != null) {
                                        if (uniqueROWS[j] == parseInt(seats[i].designator.replace(/[^0-9]/g, ''))) {
                                            if (isEntered == false) {
                                                comparewithlast = i;
                                                isEntered = true;
                                            }
                                            let seatPosition = '';
                                            for(let j = 0; j < seats[i].properties.length; j++) {
                                                if (seats[i].properties[j].code === 'WINDOW' && seats[i].properties[j].value == 'True') {
                                                    seatPosition = "WINDOW";
                                                    break;
                                                } else if (seats[i].properties[j].code === "AISLE" && seats[i].properties[j].value == "True") {
                                                    // AisleOrWindow = "AISLE";
                                                    seatPosition = "AISLE";
                                                    break;
                                                } else {
                                                    // AisleOrWindow = "MIDDLE";
                                                    seatPosition = "MIDDLE";
                                                }
                                            }

                                            if (i == 0) {
                                                arrayWithMarginSeats[count] = {
                                                    SeatDesignator: seats[i].designator,
                                                    X: seats[i].x,
                                                    Margin: 0,
                                                    SeatRow: seats[i].assignable,
                                                    Status: seats[i].availability,
                                                    Y: fncSeatGroupSelection(seats[i].group),
                                                    UnitKey: seats[i].unitKey,
                                                    seatPosition
                                                }
                                            }
                                            else {
                                                if (i == 1) {
                                                    marSeats = seats[i].x - seats[i - 1].x;
                                                    // marSeatsY = seats[i].y - seats[i-1].y;
                                                }
                                                var diff = seats[i].x - seats[i - 1].x;
                                                var diffY = seats[i].y - seats[comparewithlast == 0 ? 0 : comparewithlast - 1].y;
                                                if (diff > marSeats) {
                                                    marginAllowedSeats = 1;
                                                }
                                                else {
                                                    marginAllowedSeats = 0;
                                                }

                                                if (diffY > 2) {
                                                    marginAllowedSeatsY = 1;
                                                }
                                                else {
                                                    marginAllowedSeatsY = 0;
                                                }
                                                arrayWithMarginSeats[count] = {
                                                    SeatDesignator: seats[i].designator,
                                                    X: seats[i].x,
                                                    Margin: marginAllowedSeats,
                                                    SeatRow: seats[i].assignable,
                                                    Status: seats[i].availability,
                                                    // Y: marginAllowedSeatsY,
                                                    Y: fncSeatGroupSelection(seats[i].group),
                                                    UnitKey: seats[i].unitKey,
                                                    seatPosition
                                                }
                                            }
                                            count = count + 1;
                                        }
                                    }
                                }
                                countOfRowsFormed[j] = {
                                    id: uniqueROWS[j],
                                    dataToBind: arrayWithMarginSeats
                                };
                            }
                            //------------------------------------------------------------------ new Implementations-------------------------------------
                            // var countOfRowsFormedAftrAddingFalseSets = [];

                            for (var i = 0; i < countOfRowsFormed.length; i++) {
                                var arrayWithMarginAftrAddingFalseSets = [];
                                var fcount = 0;
                                var seatCount = "";
                                for (var j = 0; j < arrayWithMargin.length; j++) {
                                    var obj = countOfRowsFormed[i].dataToBind.find(o => o.SeatDesignator.replace(/[0-9]/g, '') === arrayWithMargin[j].SeatDesignator);
                                    if (obj != undefined) {
                                        seatCount = countOfRowsFormed[i].id;
                                        arrayWithMarginAftrAddingFalseSets[fcount] = {
                                            SeatDesignator: obj.SeatDesignator,
                                            X: obj.X,
                                            Margin: obj.Margin,
                                            SeatRow: obj.SeatRow,
                                            Status: obj.Status,
                                            Y: obj.Y,
                                            UnitKey: obj.UnitKey,
                                            hasInfant: false,
                                            hasPassenger: false,
                                            wheelChairPassenger: false,
                                            passengerTypeCode: '',
                                            passengerInfo: '',
                                            passengerGender: '',
                                            seatPosition: obj.seatPosition
                                        }
                                    }
                                    else {
                                        arrayWithMarginAftrAddingFalseSets[fcount] = {
                                            SeatDesignator: "false",
                                            X: 0,
                                            Margin: 0,
                                            SeatRow: '',
                                            Status: 0,
                                            Y: 0,
                                            UnitKey: 0,
                                            hasInfant: false,
                                            hasPassenger: false,
                                            wheelChairPassenger: false,
                                            passengerTypeCode: '',
                                            passengerInfo: '',
                                            passengerGender: '',
                                            // seatPosition: obj.seatPosition
                                        }
                                    }
                                    fcount = fcount + 1;
                                }

                                // debugger;
                                // for (var f = 0; f < arrayWithMarginAftrAddingFalseSets.length; f++) {
                                //   for (var c = 0; c < vSearchedFlightDetails.journeys.length; c++) {
                                //     for (var d = 0; d < vSearchedFlightDetails.journeys[c].segments.length; d++) {
                                //       if (vSearchedFlightDetails.journeys[c].segments[d].IsSelected == true && vSearchedFlightDetails.journeys[c].segments[d].segmentKey == segmentKey) {
                                //         for (var e = 0; e < vSearchedFlightDetails.journeys[c].segments[d].passengerSegment.length; e++) {
                                //           if (vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats.length !== 0) //vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].IsSelected==true && 
                                //           {
                                //             if (arrayWithMarginAftrAddingFalseSets[f].SeatDesignator == vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].seats[0].unitDesignator) {
                                //               var GenderType = fncPassengerInformation(vSearchedFlightDetails.journeys[c].segments[d].passengerSegment[e].passengerKey, SearchedFlightDetails)
                                //               arrayWithMarginAftrAddingFalseSets[f].PNRPassenger = true;
                                //               arrayWithMarginAftrAddingFalseSets[f].PNRPassengerGender = GenderType;
                                //             }
                                //           }
                                //         }
                                //       }
                                //     }
                                //   }
                                // }


                                countOfRowsFormedAftrAddingFalseSets[i] = {
                                    id: countOfRowsFormed[i].id,
                                    dataToBind: arrayWithMarginAftrAddingFalseSets
                                };

                            };
                            /// ------------------------------------- NEW IMPLEMENTATION ENDS HERE --------------------------------
                        }
                        debugger
                        if (passengerList) {
                            setPassengerSeatInfo(countOfRowsFormedAftrAddingFalseSets, passengerList);
                        } else {
                            setPassengerSeatInfo(countOfRowsFormedAftrAddingFalseSets);
                        }
                        
                        setcountOfRowsFormed(countOfRowsFormedAftrAddingFalseSets);
                        // fncSearchApiCallForSeat(RecordLocator, "", returnVal.data, countOfRowsFormedAftrAddingFalseSets, feeWaived);
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        // fncSearchApiCallForSeat(RecordLocator, "", returnVal.data);

                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            }
                    }
                }
            })
            .catch(err => console.log("Axios err: ", err))
        }
        
    }

    const setPassengerSeatInfo = (countOfRowsFormedAftrAddingFalseSets, paxList) => {
        let pList = [...passengerList];
        if (paxList) {
            pList = paxList;
        }
        pList.forEach(p => {
            const seat = getSegmentsDetail(flightManifest.market, 'seat', p);
            if (seat !== '') {
                updateSeatInfoInSeatMap(p, seat, countOfRowsFormedAftrAddingFalseSets);
            }
        });
    }

    const updateSeatInfoInSeatMap = (pax, seat, countOfRowsFormedAftrAddingFalseSets) => {
        const ssrs = getSegmentsDetail(flightManifest.market, 'ssrsArray', pax);
        countOfRowsFormedAftrAddingFalseSets.forEach(row => {
            if (row.id == seat.substring(0, seat.length - 1)) {
                row.dataToBind.forEach(r => {
                    if (r.SeatDesignator === seat) {
                        if (pax.infant !== null) {
                            r.hasInfant = true;
                        }
                        if (ssrs.some(ssr => (ssr.ssrCode === 'WCHC'
                            || ssr.ssrCode === 'WCHR'
                            || ssr.ssrCode === 'WCHS'
                            || ssr.ssrCode === 'WCHX'))) {
                            r.wheelChairPassenger = true;
                        }
                        r.passengerGender = pax.name.title == "MS" || pax.name.title == "MRS" ||
                            pax.name.title == "MISS" ? "FEMALE" : "MALE";
                        r.passengerTypeCode = pax.type;
                        r.hasPassenger = true;
                        if (r.passengerGender == 'MALE' && r.passengerTypeCode == 'ADT' && r.hasInfant && r.wheelChairPassenger) {
                            r.passengerInfo = 'MALEWITHWHEELCHAIRANDINFT';
                        } else if (r.passengerGender == "MALE" && r.passengerTypeCode == "ADT" && !r.hasInfant && r.wheelChairPassenger) {
                            r.passengerInfo = "MALEWITHWHEELCHAIR";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "ADT" && !r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "MALE";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "ADT" && r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "MALEWITHINFANT";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "CHD" && r.hasInfant && r.wheelChairPassenger) {
                            //------ child male
                            r.passengerInfo = "MALECHILDWITHWHEELCHAIRANDINFT";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "CHD" && !r.hasInfant && r.wheelChairPassenger) {
                            r.passengerInfo = "MALECHILDWITHWHEELCHAIR";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "CHD" && !r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "MALECHILD";
                        }
                        else if (r.passengerGender == "MALE" && r.passengerTypeCode == "CHD" && r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "MALECHILDWITHINFANT";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "ADT" && r.hasInfant && r.wheelChairPassenger) {
                            //------ FEMALE 
                            r.passengerInfo = "FEMALEWITHWHEELCHAIRANDINFT";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "ADT" && !r.hasInfant && r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALEWITHWHEELCHAIR";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "ADT" && !r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALE";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "ADT" && r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALEWITHINFANT";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "CHD" && r.hasInfant && r.wheelChairPassenger) {
                            //------ FEMALE CHILD 
                            r.passengerInfo = "FEMALECHILDWITHWHEELCHAIRANDINFT";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "CHD" && !r.hasInfant && r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALECHILDWITHWHEELCHAIR";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "CHD" && !r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALECHILD";
                        }
                        else if (r.passengerGender == "FEMALE" && r.passengerTypeCode == "CHD" && r.hasInfant && !r.wheelChairPassenger) {
                            r.passengerInfo = "FEMALECHILDWITHINFANT";
                        }
                    }
                })
            }
        });
        // console.log('aftter-------', countOfRowsFormedAftrAddingFalseSets);
    }

    const fncAddFilter = (e, property) => {
        var viewValue = e.target.checked;
        // if (viewValue !== '') {
        switch (property) {
            case 'checkedStandBy':
                setcheckedStandBy(viewValue);
                break;
            case 'totalcheckedIn':
                settotalcheckedIn(viewValue);
                break
            case 'boarded':
                setboarded(viewValue);
                break
            case 'allCheckedInWithoutSeat':
                setallCheckedInWithoutSeat(viewValue);
                break
            case 'noseat':
                setnoseat(viewValue);
                break
            case 'withExtraSeat':
                setwithExtraSeat(viewValue);
                break
            default:
                // viewPaxList = [...viewPaxList];
                break;
        }
        // }
    }

    const fncfilterByChecked = () => {
        let filteredPaxLList = [];
        let filteredPaxLListcheckedStandBy = [];
        let filteredPaxLListboarded = [];
        let filteredPaxLListtotalcheckedIn = [];
        let filteredPaxLListnoseat = [];
        let filteredPaxLListallCheckedInWithoutSeat = [];
        let filteredPaxLListwithExtraSeat = [];
        let filteredPaxByPNR = [];
        const filterFrom = flightManifest.passengerList;
        if (checkedStandBy
            || boarded
            || totalcheckedIn
            || noseat
            || allCheckedInWithoutSeat
            || withExtraSeat
            || recordlocator !== ''
            || filterName !== '') {
            if (checkedStandBy) {
                filteredPaxLListcheckedStandBy = filterFrom.filter(p =>
                    getSegmentsDetail(flightManifest.market, 'classOfService', p) === 'Z'
                    && getSegmentsDetail(flightManifest.market, 'liftStatus', p) === 1
                );
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListcheckedStandBy];
            }
            if (boarded) {
                filteredPaxLListboarded = filterFrom.filter((pax) => getSegmentsDetail(flightManifest.market, 'liftStatus', pax) === 2);
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListboarded];
            }
            if (totalcheckedIn) {
                filteredPaxLListtotalcheckedIn = filterFrom.filter((pax) => getSegmentsDetail(flightManifest.market, 'liftStatus', pax) === 1);
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListtotalcheckedIn];
            }
            if (noseat) {
                filteredPaxLListnoseat = filterFrom.filter(pax => getSegmentsDetail(flightManifest.market, 'seat', pax) === '');
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListnoseat];
            }
            if (allCheckedInWithoutSeat) {
                filteredPaxLListallCheckedInWithoutSeat = filterFrom.filter(pax => getSegmentsDetail(flightManifest.market, 'seat', pax) === ''
                    && getSegmentsDetail(flightManifest.market, 'liftStatus', pax) === 1);
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListallCheckedInWithoutSeat];
            }
            if (withExtraSeat) {
                filteredPaxLListwithExtraSeat = filterFrom.filter(pax =>
                    getSegmentsDetail(flightManifest.market, 'ssrs', pax)
                        .split(' ,')
                        .includes('EXS1') ||
                    getSegmentsDetail(flightManifest.market, 'ssrs', pax)
                        .split(' ,')
                        .includes('EXS2')
                );
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxLListwithExtraSeat];
            }
            if (recordlocator !== '') {
                filteredPaxByPNR = filterFrom.filter(pax => pax.recordLocator === recordlocator);
                filteredPaxLList = [...filteredPaxLList, ...filteredPaxByPNR];
            }
            if (filterName !== '') {
                const passengers = [...filterFrom];
                const filteredPax = [];
                const propertyToLook = ['first', 'last'];
                passengers.forEach(p => {
                    const { name } = p;
                    const keysInName = Object.keys(name);
    
                    keysInName.forEach((k, i) => {
                        if (propertyToLook.includes(k)) {
                            if (name[k] !== null && name[k].toLowerCase().indexOf(filterName.toLowerCase()) > -1) {
                                filteredPax.push(p);
                            }
                        }
                    })
                });
                filteredPaxLList = [...filteredPaxLList, ...filteredPax];
            }
            setPassengerList(filteredPaxLList);
        } else {
            fncClearAllFilters();
        }
    }

    const fncClearAllFilters = () => {
        setcheckedStandBy(false);
        setboarded(false);
        settotalcheckedIn(false);
        setnoseat(false);
        setwithExtraSeat(false);
        setallCheckedInWithoutSeat(false);
        setfilterName('');
        setRecordlocator('');
        setPassengerList(flightManifest.passengerList.length ? flightManifest.passengerList : []);
    }

    const fncFilterByRecordLocator = (e) => {
        const value = e.target.value;
        const alphaNumeric = /^[0-9a-zA-Z]+$/;
        if (value !== "") {
            if (value.match(alphaNumeric)) {
                if (value.length <= 6) {
                    setRecordlocator(value.toUpperCase());
                }
            }
        } else {
            setRecordlocator(value);
        }
    }

    const fncFilterByName = (e) => {
        const value = e.target.value;
        if (value !== "") {
            setfilterName(value.toLowerCase());
        } else {
            setfilterName(value);
        }
    }

    const ssrsOnOtherSeats = (SeatData) => {

        let maxClass = '', normalClass = '';
        if (SeatData.hasPassenger) {
            if (SeatData.Status === 'Reserved') {
                // maxClass = 'maxseat male reservedSeat';
                // normalClass = 'reservedSeat';
                switch (SeatData.passengerInfo) {
                    case 'MALEWITHWHEELCHAIRANDINFT':
                        maxClass = "maxseat maleWheelChairWithInfant"
                        normalClass = "maleWheelChairWithInfant"
                        break;
                    case 'MALEWITHWHEELCHAIR':
                        maxClass = "maxseat maleWheelChair"
                        normalClass = "maleWheelChair"
                        break
                    case 'MALE':
                        maxClass = "maxseat male"
                        normalClass = "male"
                        break
                    case 'MALEWITHINFANT':
                        maxClass = "maxseat maleWithChild"
                        normalClass = "maleWithChild"
                        break
                    case 'MALECHILDWITHWHEELCHAIRANDINFT':
                        maxClass = "maxseat maleWheelChairWithInfant"
                        normalClass = "maleWheelChairWithInfant"
                        break
                    case 'MALECHILDWITHWHEELCHAIR':
                        maxClass = "maxseat maleChildWheelChair"
                        normalClass = "maleChildWheelChair"
                        break
                    case 'MALECHILD':
                        maxClass = "maxseat maleChild"
                        normalClass = "maleChild"
                        break
                    case 'MALECHILDWITHINFANT':
                        maxClass = "maxseat maleWithChild"
                        normalClass = "maleWithChild"
                        break
                    case 'FEMALEWITHWHEELCHAIRANDINFT':
                        maxClass = "maxseat femaleWheelChairWithInfant"
                        normalClass = "femaleWheelChairWithInfant"
                        break
                    case 'FEMALEWITHWHEELCHAIR':
                        maxClass = "maxseat femaleWheelChair"
                        normalClass = "femaleWheelChair"
                        break
                    case 'FEMALE':
                        maxClass = "maxseat female"
                        normalClass = "female"
                        break
                    case 'FEMALEWITHINFANT':
                        maxClass = "maxseat femaleWithInfant"
                        normalClass = "femaleWithInfant"
                        break
                    case 'FEMALECHILDWITHWHEELCHAIRANDINFT':
                        maxClass = "maxseat femaleWheelChairWithInfant"
                        normalClass = "femaleWheelChairWithInfant"
                        break
                    case 'FEMALECHILDWITHWHEELCHAIR':
                        maxClass = "maxseat femaleChildWheelChair"
                        normalClass = "femaleChildWheelChair"
                        break
                    case 'FEMALECHILD':
                        maxClass = "maxseat femaleChild"
                        normalClass = "femaleChild"
                        break
                    case 'FEMALECHILDWITHINFANT':
                        maxClass = "maxseat femaleWithInfant"
                        normalClass = "femaleWithInfant"
                        break
                    default:
                        maxClass = 'maxseat reservedSeat';
                        normalClass = 'reservedSeat';
                        break;
                }
            }
            if (SeatData.Status === 'HeldForAnotherSession') {
                maxClass = 'maxseat heldForAnotherSession';
                normalClass = 'heldForAnotherSession';
            }
        }


        // if (seatIdentificationData.length) {
        //   let isInfant = false;
        //   let isWheelchair = false;
        //   let isUNMR = false;

        //   if (selectedSeg.length > 0) {
        //     let ssrLeg = [];
        //     let allSSRBlockedSeats = [];
        //     selectedSeg[0].legs.forEach(leg => {
        //       ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);

        //     })
        //     isInfant = ssrLeg[0].rownoInfant.some(i => i === SeatData.SeatDesignator);
        //     isWheelchair = ssrLeg[0].rownoWheelchair.some(i => i === SeatData.SeatDesignator);
        //     isUNMR = ssrLeg[0].rownoUNMR.some(i => i === SeatData.SeatDesignator);
        //   }
        //   if (SeatData.Status === "Reserved") {

        //     if (isInfant) {
        //       maxClass = 'maxInfantReserved';
        //       normalClass = 'normalInfantReserved';
        //     }
        //     if (isWheelchair) {
        //       maxClass = 'maxWheelchairReserved';
        //       normalClass = 'normalWheelchairReserved';
        //     }
        //     if (isUNMR) {
        //       maxClass = 'maxUNMRReserved';
        //       normalClass = 'normalUNMRReserved';
        //     }
        //   }
        //   if (SeatData.Status === 'HeldForAnotherSession') {
        //     if (isInfant) {
        //       maxClass = 'maxInfantHeldForAnotherSession';
        //       normalClass = 'normalInfantHeldForAnotherSession';
        //     }
        //     if (isWheelchair) {
        //       maxClass = 'maxWheelchairHeldForAnotherSession';
        //       normalClass = 'normalWheelchairHeldForAnotherSession';
        //     }
        //     if (isUNMR) {
        //       maxClass = 'maxUNMRHeldForAnotherSession';
        //       normalClass = 'normalUNMRHeldForAnotherSession';
        //     }
        //   }
        // }

        return (
            <div>
                <input class={SeatData.Y == 1 ? maxClass : normalClass} type="checkbox" tabIndex={-1} />
                <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""} tabIndex={-1}</label>
            </div>
        );
    }

    const classForCheckedIn = (SeatData) => {

        let cls =
            // fncCheckPassengerCheckedInStatus(SeatData.SeatDesignator) ? st_UserSeatDetails.length == 0 ? "" : st_UserSeatDetails.map((data) =>
            //   // data.SelectedPassenger ? "selected" : 
            //   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //     "maxseat maleWheelChairWithInfant selected"
            //     :
            //     SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //       "maxseat maleWheelChair selected"
            //       :
            //       SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //         "maxseat male selected"
            //         :
            //         SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //           "maxseat maleWithChild selected" // need to change the image class
            //           :
            //           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //             "maxseat maleWheelChairWithInfant selected"
            //             :
            //             SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //               "maxseat maleChildWheelChair selected"
            //               :
            //               SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                 "maxseat maleChild selected"
            //                 :
            //                 SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                   "maxseat maleWithChild selected" // need to change the image class
            //                   :
            //                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                     "maxseat femaleWheelChairWithInfant selected"
            //                     :
            //                     SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                       "maxseat femaleWheelChair selected"
            //                       :
            //                       SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                         "maxseat female selected"
            //                         :
            //                         SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                           "maxseat femaleWithInfant selected"
            //                           :
            //                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                             "maxseat femaleWheelChairWithInfant selected"
            //                             :
            //                             SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                               "maxseat femaleChildWheelChair selected"
            //                               :
            //                               SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                 "maxseat femaleChild selected"
            //                                 :
            //                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                   "maxseat femaleWithInfant selected"
            //                                   :
            //                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                     "maleWheelChairWithInfant selected"
            //                                     :
            //                                     SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                       "maleWheelChair selected"
            //                                       :
            //                                       SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                         "male selected"
            //                                         :
            //                                         SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                           "maleWithChild selected" // need to change the image class
            //                                           :
            //                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                             "maleWheelChairWithInfant selected"
            //                                             :
            //                                             SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                               "maleChildWheelChair selected"
            //                                               :
            //                                               SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                 "maleChild selected"
            //                                                 :
            //                                                 SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                   "maleWithChild selected" // need to change the image class
            //                                                   :
            //                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                     "femaleWheelChairWithInfant selected"
            //                                                     :
            //                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                       "femaleWheelChair selected"
            //                                                       :
            //                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                         "female selected"
            //                                                         :
            //                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                           "femaleWithInfant selected"
            //                                                           :
            //                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                             "femaleWheelChairWithInfant selected"
            //                                                             :
            //                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                               "femaleChildWheelChair selected"
            //                                                               :
            //                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                                 "femaleChild selected"
            //                                                                 :
            //                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL && data.SelectedPassenger ?
            //                                                                   "femaleWithInfant selected"
            //                                                                   :
            //                                                                   SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                     "maxseat maleWheelChairWithInfant"
            //                                                                     :
            //                                                                     SeatData.Y == 1 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                       "maxseat maleWheelChair"
            //                                                                       :
            //                                                                       SeatData.Y == 1 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                         "maxseat male"
            //                                                                         :
            //                                                                         SeatData.Y == 1 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                           "maxseat maleWithChild" // need to change the image class
            //                                                                           :
            //                                                                           SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                             "maxseat maleWheelChairWithInfant"
            //                                                                             :
            //                                                                             SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                               "maxseat maleChildWheelChair"
            //                                                                               :
            //                                                                               SeatData.Y == 1 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                 "maxseat maleChild"
            //                                                                                 :
            //                                                                                 SeatData.Y == 1 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                   "maxseat maleWithChild" // need to change the image class
            //                                                                                   :
            //                                                                                   SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                     "maxseat femaleWheelChairWithInfant"
            //                                                                                     :
            //                                                                                     SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                       "maxseat femaleWheelChair"
            //                                                                                       :
            //                                                                                       SeatData.Y == 1 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                         "maxseat female"
            //                                                                                         :
            //                                                                                         SeatData.Y == 1 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                           "maxseat femaleWithInfant"
            //                                                                                           :
            //                                                                                           SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                             "maxseat femaleWheelChairWithInfant"
            //                                                                                             :
            //                                                                                             SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                               "maxseat femaleChildWheelChair"
            //                                                                                               :
            //                                                                                               SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                 "maxseat femaleChild"
            //                                                                                                 :
            //                                                                                                 SeatData.Y == 1 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                   "maxseat femaleWithInfant"
            //                                                                                                   :
            //                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                     "maleWheelChairWithInfant"
            //                                                                                                     :
            //                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "MALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                       "maleWheelChair"
            //                                                                                                       :
            //                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "MALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                         "male"
            //                                                                                                         :
            //                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "MALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                           "maleWithChild" // need to change the image class
            //                                                                                                           :
            //                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                             "maleWheelChairWithInfant"
            //                                                                                                             :
            //                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                               "maleChildWheelChair"
            //                                                                                                               :
            //                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "MALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                 "maleChild"
            //                                                                                                                 :
            //                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "MALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                   "maleWithChild" // need to change the image class
            //                                                                                                                   :
            //                                                                                                                   SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                     "femaleWheelChairWithInfant"
            //                                                                                                                     :
            //                                                                                                                     SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                       "femaleWheelChair"
            //                                                                                                                       :
            //                                                                                                                       SeatData.Y == 0 && data.PassengerInfo == "FEMALE" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                         "female"
            //                                                                                                                         :
            //                                                                                                                         SeatData.Y == 0 && data.PassengerInfo == "FEMALEWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                           "femaleWithInfant"
            //                                                                                                                           :
            //                                                                                                                           SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                             "femaleWheelChairWithInfant"
            //                                                                                                                             :
            //                                                                                                                             SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHWHEELCHAIR" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                               "femaleChildWheelChair"
            //                                                                                                                               :
            //                                                                                                                               SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILD" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                                 "femaleChild"
            //                                                                                                                                 :
            //                                                                                                                                 SeatData.Y == 0 && data.PassengerInfo == "FEMALECHILDWITHINFANT" && SeatData.SeatDesignator == data.SEATDETAIL ?
            //                                                                                                                                   "femaleWithInfant"
            //                                                                                                                                   : "")
            //   :
            SeatData.hasPassenger ?
                SeatData.Y == 1 && SeatData.passengerInfo == "MALEWITHWHEELCHAIRANDINFT" ?
                    "maxseat maleWheelChairWithInfant-checkedIn"
                    :
                    SeatData.Y == 1 && SeatData.passengerInfo == "MALEWITHWHEELCHAIR" ?
                        "maxseat maleWheelChair-checkedIn"
                        :
                        SeatData.Y == 1 && SeatData.passengerInfo == "MALE" ?
                            "maxseat male-checkedIn"
                            :
                            SeatData.Y == 1 && SeatData.passengerInfo == "MALEWITHINFANT" ?
                                "maxseat maleWithChild-checkedIn" // need to change the image class
                                :
                                SeatData.Y == 1 && SeatData.passengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                                    "maxseat maleWheelChairWithInfant-checkedIn"
                                    :
                                    SeatData.Y == 1 && SeatData.passengerInfo == "MALECHILDWITHWHEELCHAIR" ?
                                        "maxseat maleChildWheelChair-checkedIn"
                                        :
                                        SeatData.Y == 1 && SeatData.passengerInfo == "MALECHILD" ?
                                            "maxseat maleChild-checkedIn"
                                            :
                                            SeatData.Y == 1 && SeatData.passengerInfo == "MALECHILDWITHINFANT" ?
                                                "maxseat maleWithChild-checkedIn" // need to change the image class
                                                :
                                                SeatData.Y == 1 && SeatData.passengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                                    "maxseat femaleWheelChairWithInfant-checkedIn"
                                                    :
                                                    SeatData.Y == 1 && SeatData.passengerInfo == "FEMALEWITHWHEELCHAIR" ?
                                                        "maxseat femaleWheelChair-checkedIn"
                                                        :
                                                        SeatData.Y == 1 && SeatData.passengerInfo == "FEMALE" ?
                                                            "maxseat female-checkedIn"
                                                            :
                                                            SeatData.Y == 1 && SeatData.passengerInfo == "FEMALEWITHINFANT" ?
                                                                "maxseat femaleWithInfant-checkedIn"
                                                                :
                                                                SeatData.Y == 1 && SeatData.passengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                    "maxseat femaleWheelChairWithInfant-checkedIn"
                                                                    :
                                                                    SeatData.Y == 1 && SeatData.passengerInfo == "FEMALECHILDWITHWHEELCHAIR" ?
                                                                        "maxseat femaleChildWheelChair-checkedIn"
                                                                        :
                                                                        SeatData.Y == 1 && SeatData.passengerInfo == "FEMALECHILD" ?
                                                                            "maxseat femaleChild-checkedIn"
                                                                            :
                                                                            SeatData.Y == 1 && SeatData.passengerInfo == "FEMALECHILDWITHINFANT" ?
                                                                                "maxseat femaleWithInfant-checkedIn"
                                                                                :
                                                                                SeatData.Y == 0 && SeatData.passengerInfo == "MALEWITHWHEELCHAIRANDINFT" ?
                                                                                    "maleWheelChairWithInfant-checkedIn"
                                                                                    :
                                                                                    SeatData.Y == 0 && SeatData.passengerInfo == "MALEWITHWHEELCHAIR" ?
                                                                                        "maleWheelChair-checkedIn"
                                                                                        :
                                                                                        SeatData.Y == 0 && SeatData.passengerInfo == "MALE" ?
                                                                                            "male-checkedIn"
                                                                                            :
                                                                                            SeatData.Y == 0 && SeatData.passengerInfo == "MALEWITHINFANT" ?
                                                                                                "maleWithChild-checkedIn" // need to change the image class
                                                                                                :
                                                                                                SeatData.Y == 0 && SeatData.passengerInfo == "MALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                                                    "maleWheelChairWithInfant-checkedIn"
                                                                                                    :
                                                                                                    SeatData.Y == 0 && SeatData.passengerInfo == "MALECHILDWITHWHEELCHAIR" ?
                                                                                                        "maleChildWheelChair-checkedIn"
                                                                                                        :
                                                                                                        SeatData.Y == 0 && SeatData.passengerInfo == "MALECHILD" ?
                                                                                                            "maleChild-checkedIn"
                                                                                                            :
                                                                                                            SeatData.Y == 0 && SeatData.passengerInfo == "MALECHILDWITHINFANT" ?
                                                                                                                "maleWithChild-checkedIn" // need to change the image class
                                                                                                                :
                                                                                                                SeatData.Y == 0 && SeatData.passengerInfo == "FEMALEWITHWHEELCHAIRANDINFT" ?
                                                                                                                    "femaleWheelChairWithInfant-checkedIn"
                                                                                                                    :
                                                                                                                    SeatData.Y == 0 && SeatData.passengerInfo == "FEMALEWITHWHEELCHAIR" ?
                                                                                                                        "femaleWheelChair-checkedIn"
                                                                                                                        :
                                                                                                                        SeatData.Y == 0 && SeatData.passengerInfo == "FEMALE" ?
                                                                                                                            "female-checkedIn"
                                                                                                                            :
                                                                                                                            SeatData.Y == 0 && SeatData.passengerInfo == "FEMALEWITHINFANT" ?
                                                                                                                                "femaleWithInfant-checkedIn"
                                                                                                                                :
                                                                                                                                SeatData.Y == 0 && SeatData.passengerInfo == "FEMALECHILDWITHWHEELCHAIRANDINFT" ?
                                                                                                                                    "femaleWheelChairWithInfant-checkedIn"
                                                                                                                                    :
                                                                                                                                    SeatData.Y == 0 && SeatData.passengerInfo == "FEMALECHILDWITHWHEELCHAIR" ?
                                                                                                                                        "femaleChildWheelChair-checkedIn"
                                                                                                                                        :
                                                                                                                                        SeatData.Y == 0 && SeatData.passengerInfo == "FEMALECHILD" ?
                                                                                                                                            "femaleChild-checkedIn"
                                                                                                                                            :
                                                                                                                                            SeatData.Y == 0 && SeatData.passengerInfo == "FEMALECHILDWITHINFANT" ?
                                                                                                                                                "femaleWithInfant-checkedIn"
                                                                                                                                                : "" :
                SeatData.Y == 1 ?
                    "maxseat checkin"
                    :
                    SeatData.Y == 0 ?
                        "checkin"
                        :
                        ""

        // if (seatIdentificationData.length) {
        //   const { journeyKey, segmentKey } = selectedPassengerAndSegment;
        //   const selectedJourney = SearchedFlightDetails.journeys.filter(j => j.journeyKey === journeyKey);
        //   const selectedSeg = selectedJourney.length && selectedJourney[0].segments.filter(s => s.segmentKey === segmentKey && s.IsSelected);
        //   let isInfant = false;
        //   let isWheelchair = false;
        //   let isUNMR = false;

        //   if (selectedSeg.length > 0) {
        //     let ssrLeg = [];
        //     let allSSRBlockedSeats = [];
        //     selectedSeg[0].legs.forEach(leg => {
        //       ssrLeg = seatIdentificationData.filter(si => si.legkey === leg.legKey);

        //     })
        //     isInfant = ssrLeg[0].rownoInfant.some(i => i === SeatData.SeatDesignator);
        //     isWheelchair = ssrLeg[0].rownoWheelchair.some(i => i === SeatData.SeatDesignator);
        //     isUNMR = ssrLeg[0].rownoUNMR.some(i => i === SeatData.SeatDesignator);
        //   }
        //   if (SeatData.Status == "CheckedIn") {

        //     if (isInfant) {
        //       cls = SeatData.Y == 1 ? 'maxInfantCheckedin' : 'normalInfantCheckedin';
        //     }
        //     if (isWheelchair) {
        //       cls = SeatData.Y == 1 ? 'maxWheelchairCheckedin' : 'normalWheelchairCheckedin';
        //     }
        //     if (isUNMR) {
        //       cls = SeatData.Y == 1 ? 'maxUNMRCheckedin' : 'normalUNMRCheckedin';
        //     }
        //   }
        // }
        return cls.toString().replaceAll(',', '');
    }

    const fncCheckDepartedFlight = () => {
        var now = moment();
        const DepartureTime = flightTripStatus.operationDetails && flightTripStatus.operationDetails.tripOperationTimes
        && flightTripStatus.operationDetails.tripOperationTimes.departureTimes.estimated
        ? flightTripStatus.operationDetails.tripOperationTimes.departureTimes.estimated
        : flightTripStatus.operationDetails.tripOperationTimes.departureTimes.scheduled;
        const then = moment(DepartureTime);
        if (now > then) {
            return true;
        } else {
            return false;
        }
    }

    const callSeatMapAndManifest = async () => {
        
        try {
            const manifestData = await fncLoadFlightManifestDataForBoarding(selectedLeg);
            const tripData = await fncGetTripStatus(selectedLeg);
            if ((manifestData.status == "401" && manifestData.data == "") ||  (tripData.status == "401" && tripData.data == "")) {
                document.getElementById("showAndHideSpinner").style.display = "none";
                //notify(returnVal.statusText);
                settriggerModal(true);
            } else {
                if (!manifestData.data.isError) {
                    // debugger
                    const { passengerList } = manifestData.data.data;
                    const mapAndCountByRecordLocator = mapToProp(passengerList, 'recordLocator');
                    passengerList.length && passengerList.forEach(pax => {
                        pax.isChecked = false;
                        pax.isSelectedForSeatAssign = false;
                        pax.recordLocatorCount = mapAndCountByRecordLocator[pax.recordLocator] === 1 ? '' : `1/${mapAndCountByRecordLocator[pax.recordLocator]}`;
                    });
                    setPassengerList(passengerList);
                    dispatch(flightManifestBoardingCredential(
                        {
                            type: '',
                            flightManifestBoarding: manifestData.data.data
                        }
                    ))

                } else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                        settriggerModal(true);
                        } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                    }
                }

                if (!tripData.data.isError) {
                    const { destinationDetails, operationDetails, originDetails, irop } = tripData.data;
                    dispatch(flightTripBoardingCredential(
                        {
                            type: '',
                            flightTripBoarding: { destinationDetails, operationDetails, originDetails, irop }
                        }
                    ))
                } else {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                        settriggerModal(true);
                        } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                    }
                }
                document.getElementById("showAndHideSpinner").style.display = "none";
                dispatch(setflightLegKeyCredential({
                    type: '',
                    selectedFlight: selectedLeg
                }));
                // await 
                callSeatMap(manifestData.data.data.passengerList);
                // this.forceUpdate();
                // forceUpdate();
                // window.location.reload();
                // const navPage = pageNavigationForBoardingModule('FlightSearch');
                // history.push("/"+navPage);          
            }
        } catch (e) {
            console.log('error in loading flight data', e);
            document.getElementById("showAndHideSpinner").style.display = "none";
            notify(e.message);
        }
    }

    const fncSeatSelection = async (seatData, SEATMAP, dataId) => {
        // console.log('SeatData, SEATMAP, dataId', seatData, SEATMAP, dataId);
        // console.log('seatMapTask', seatMapTask, selectedRow, seatIdentificationData);
        // debugger
        const selectedpax = selectedRow !== -1 ? passengerList.find((item, index) => index === selectedRow) : null;
        if (seatIdentificationData.length > 0) {
            let ssrLeg = [];
            let allSSRBlockedSeats = [];
            ssrLeg = seatIdentificationData.filter(si => si.legkey === selectedLeg);
            ssrLeg.forEach(s => {
            allSSRBlockedSeats.push(...s.rownoInfant, ...s.rownoUNMR, ...s.rownoWheelchair);
            });

            // if (allSSRBlockedSeats.length) {
                // console.log('selectedpax', selectedpax);
                if (seatMapTask === 'BLOCKSEAT') {
                    // console.log('seatMapTask', seatMapTask, seatData.SeatDesignator);
                    fncEnterSeatToBlock({ target: { value: seatData.SeatDesignator}});
                } else {
                    if (selectedpax) {
                        // const liftStatusOfSelectedPax = getSegmentsDetail(flightManifest.market, 'liftStatus', selectedpax);
                        // if ([1,2].includes(liftStatusOfSelectedPax)) {
                        //     notify('Cannot reassign seat(s) to Checked In/Boarded passenger(s)');
                        //     return;
                        // }
                        const paxSsr = getSegmentsDetail(flightManifest.market, 'ssrsArray', selectedpax);
                        if (allSSRBlockedSeats.length && (selectedpax.infant || paxSsr.filter(ssr => seatBlockSSRS.includes(ssr.ssrCode)).length > 0)) {
                            const blockedRows = allSSRBlockedSeats.map(i => i = i.replace(/\D/g, ''));
                            const currentSeatPickedInRow = seatData.SeatDesignator.replace(/\D/g, '');
                            if (blockedRows.includes(currentSeatPickedInRow)) {
                            setShowSSRSeatNotAvailableErrorPopup(true);
                            return;
                            }
                        }
                        const isFlightDeparted = fncCheckDepartedFlight();
                        if (!isFlightDeparted) {
                            if (selectedpax && seatData.Status === "Open") {
                                const haveSeat = getSegmentsDetail(flightManifest.market, 'seat', selectedpax);
    
                                // console.log('selectedpax----------', selectedpax, haveSeat);
                                if (haveSeat !=='') {
                                    const unAssignSeatRequest = [];
                                    const seatmap = [...st_countOfRowsFormed];
                                    const { passengerKey, recordLocator } = selectedpax;
                                    const row = haveSeat.substring(haveSeat.length - 1, 0);
                                    const seatrow = seatmap.find(s => s.id == row)
                                    const data = seatrow.dataToBind.find(d => d.SeatDesignator === haveSeat);
                                    if (data) {
                                        const { UnitKey } = data;
                                        unAssignSeatRequest.push(
                                            {
                                                "recordlocator": recordLocator,
                                                "passengerKey": passengerKey,
                                                "unitKey": UnitKey,
                                                "waiveFee": false,
                                                "ignoreSeatSsrs": true,
                                                "Mode": "Boarding"
                                            }
                                        )
                                    }
                                    fncUnAssignPassengerSeats(unAssignSeatRequest)
                                    .then((returnVal) => {
                                        if (returnVal.status == "401" && returnVal.data == "") {
                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                            // notify(returnVal.statusText);
                                            settriggerModal(true);
                                        } else {
                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                            if (!returnVal.data.isError && returnVal.status === 200) {
                                                const { passengerKey, recordLocator } = selectedpax;
                                const flightNo  = flightManifest.market.identifier.identifier;
                                const { segments } = selectedpax.services[0];
                                const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
                                const IsAutoAssign = false;
                                const AutoAssignSeatRequest = null;
                                const request = [{ 
                                    "passengerKey": passengerKey,
                                    "JourneyKey": currentSegment.segmentKey,
                                    "unitKey": seatData.UnitKey,
                                    "waiveFee": false,
                                    "SegmentKey":  currentSegment.segmentKey,
                                    "RecordLocator": recordLocator,
                                    "collectedCurrencyCode": "INR",
                                    "ignoreSeatSsrs": true
                                }]
                                fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests: request, Mode: 'Boarding' })
                                .then((returnVal) => {
                                    if (returnVal.status == "401" && returnVal.data == "") {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        // notify(returnVal.statusText);
                                        settriggerModal(true);
                                    } else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        if (!returnVal.data.isError && returnVal.status === 200) {
                                             callSeatMapAndManifest();
                                        } else {
                                            console.log('err', returnVal.data);
                                            notify('Something went wrong.');
                                        }
                                    }
                                })
                                .catch(e => console.log('err-----',e));
                                                //  callSeatMapAndManifest();
                                            } else {
                                                document.getElementById("showAndHideSpinner").style.display = "none";
                                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                    settriggerModal(true);
                                                    } else {
                                                        notify('Something went wrong.');
                                                }
                                                console.log('err', returnVal.data);
                                            }
                                        }
                                    })
                                    .catch(e => console.log('err-----',e));
                                }
                                const { passengerKey, recordLocator } = selectedpax;
                                const flightNo  = flightManifest.market.identifier.identifier;
                                const { segments } = selectedpax.services[0];
                                const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
                                const IsAutoAssign = false;
                                const AutoAssignSeatRequest = null;
                                const request = [{ 
                                    "passengerKey": passengerKey,
                                    "JourneyKey": currentSegment.segmentKey,
                                    "unitKey": seatData.UnitKey,
                                    "waiveFee": false,
                                    "SegmentKey":  currentSegment.segmentKey,
                                    "RecordLocator": recordLocator,
                                    "collectedCurrencyCode": "INR",
                                    "ignoreSeatSsrs": true
                                }]
                                fncAssignPassengerSeats({ IsAutoAssign, AutoAssignSeatRequest, AssignSeatRequests: request, Mode: 'Boarding' })
                                .then((returnVal) => {
                                    if (returnVal.status == "401" && returnVal.data == "") {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        // notify(returnVal.statusText);
                                        settriggerModal(true);
                                    } else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        if (!returnVal.data.isError && returnVal.status === 200) {
                                             callSeatMapAndManifest();
                                        } else {
                                            console.log('err', returnVal.data);
                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                                    settriggerModal(true);
                                            } else {
                                                notify('Something went wrong.');
                                            }
                                        }
                                    }
                                })
                                .catch(e => console.log('err-----',e));
                                fncClearAllFilters();
                            }
                        } else {
                            //modal popup displaying 
                            setshowErrorPopup(true);
                        }
                    } else {
                        setshowPaxNotSelectedError(true);
                    }
                }
            // }
        }
    }

    const fncSelectPassenger = (e, pax) => {
        // console.log('e.target.checked', e.target.checked, pax);
        const passengers = [...passengerList];
        passengers.forEach((p) => {
            if (p.recordLocator === pax.recordLocator && p.passengerKey === pax.passengerKey) {
                p.isSelectedForSeatAssign = e.target.checked;
            }
        });
        setPassengerList(passengers);
    }

    const fncSelectAllPassengers = (e) => {
        setselectAllPassengers(e.target.checked);
        // console.log('setselectAllPassenger', e.target.checked);
        const allPassenger = [...passengerList];
        // debugger
        allPassenger.forEach(pax => {
            pax.isSelectedForSeatAssign = e.target.checked;
        });
        // console.log('allPassenger', allPassenger);
        setPassengerList(allPassenger);
    }

    const printBoardingPass = () => {
        const passengers = [...passengerList];
        const selectedPassengers = passengers.filter(pax => pax.isSelectedForSeatAssign);
        // console.log('selectedPassengers', selectedPassengers);
        const dumyRequest = [
            {
                "RecordLocator": "N6153F",
                "segmentKey": "",
                "journeyKey": "U0d_ODcwOX4gfn5ERUx_MTAvMDEvMjAyMyAxODo1NX5CT01_MTAvMDEvMjAyMyAyMToyNX5_",
                "boardingPassPassengerFilterRequest": {
                    "passengerKeys": [
                        "MCFBRFQ-"
                    ],
                    "source": "O"
                }
            }
        ]
    }

    const autoAssignSeat = async () => {
        const passengers = [...passengerList];
        const IsAutoAssign = true;
        const AutoAssignSeatRequest = [];
        
        const selectedPassengers = passengers.filter(pax => pax.isSelectedForSeatAssign);
        // selectedPassengers.forEach(p => {
        //     const liftStatusOfSelectedPax = getSegmentsDetail(flightManifest.market, 'liftStatus', p);
        //         if ([1,2].includes(liftStatusOfSelectedPax)) {
        //             notify('Cannnot reassign seat(s) to Checked In/Boarded passenger(s)');
        //             return;
        //         }
        // });
        const flightNo  = flightManifest.market.identifier.identifier;
        const { segments } = selectedPassengers[0].services[0];
        const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
        // console.log('autoAssignSeat', selectedPassengers);
        selectedPassengers.forEach((p, i) => {
            const { passengerKey, recordLocator } = p;
            AutoAssignSeatRequest.push({
                "primaryPassengerKey": passengerKey,
                "SegmentKey": '', //currentSegment.segmentKey,
                "JourneyKey": currentSegment.segmentKey,
                "waiveFee": false,
                "RecordLocator": recordLocator,
                "seatedNearPrimary": [{passengerKey: passengerKey}]
            })
        })
        // console.log('AutoAssignSeatRequest', AutoAssignSeatRequest);
        // debugger
        fncAutoAssignPassengerSeats(IsAutoAssign, AutoAssignSeatRequest, 'Boarding')
        .then((returnVal) => {
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                // notify(returnVal.statusText);
                settriggerModal(true);
            } else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                if (!returnVal.data.isError && returnVal.status === 200) {
                     callSeatMapAndManifest();
                     fncClearAllFilters();
                } else {
                    console.log('err', returnVal.data);
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                    } else {
                        notify('Something went wrong.');
                    }
                }
            }
        })
        .catch(e => console.log('err-----',e));
    }

    const unAssignSeat = async () => {
        const unAssignSeatRequest = [];
        const passengers = [...passengerList];
        const selectedPassengers = passengers.filter(pax => pax.isSelectedForSeatAssign);
        // const flightNo  = flightManifest.market.identifier.identifier;
        // const { segments } = selectedPassengers[0].services[0];
        // const currentSegment = segments.filter(s => s.market.identifier.identifier === flightNo)[0];
        selectedPassengers.forEach((p, i) => {
            const { passengerKey, recordLocator } = p;
            const seatUnit = getSegmentsDetail(flightManifest.market, 'seat', p);
            const seatmap = [...st_countOfRowsFormed];
            const row = seatUnit.substring(seatUnit.length - 1, 0);
            // console.log('--------', seatUnit.substring(seatUnit.length - 1, 0));
            const seatrow = seatmap.find(s => s.id == row)
            const data = seatrow.dataToBind.find(d => d.SeatDesignator === seatUnit);
            // const currentSeatPickedInRow = seatmap.SeatDesignator.replace(/\D/g, '');
            // console.log('seatmap=====', data); // seatmap, seatUnit, seatrow);
            if (data) {
                const { UnitKey } = data;
                unAssignSeatRequest.push(
                    {
                        "recordlocator": recordLocator,
                        "passengerKey": passengerKey,
                        "unitKey": UnitKey,
                        "waiveFee": false,
                        "ignoreSeatSsrs": true,
                        "Mode": "Boarding"
                    }
                )
            }
        })
        debugger
        fncUnAssignPassengerSeats(unAssignSeatRequest)
        .then((returnVal) => {
            if (returnVal.status == "401" && returnVal.data == "") {
                document.getElementById("showAndHideSpinner").style.display = "none";
                // notify(returnVal.statusText);
                settriggerModal(true);
            } else {
                document.getElementById("showAndHideSpinner").style.display = "none";
                if (!returnVal.data.isError && returnVal.status === 200) {
                     callSeatMapAndManifest();
                     fncClearAllFilters();
                } else {
                    
                    console.log('err', returnVal.data);
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                            settriggerModal(true);
                    } else {
                        notify('Something went wrong.');
                    }
                    
                }
            }
        })
        .catch(e => console.log('err-----',e));
    }

    const fncEnterSeatToBlock = (e) => {
        const value = e.target.value;
        // console.log('seat to block', value);
        // debugger
        if(value !== '' && value.length < 4) {
            const s = value.toUpperCase();
            const seatmap = [...st_countOfRowsFormed];
            const row = s.substring(s.length - 1, 0);
            const seatrow = seatmap.find(s => s.id == row);
            if (seatrow) {
                const seatdata = seatrow.dataToBind.find(d => d.SeatDesignator === s);
                // console.log('daata=========', seatdata);
                if (seatdata && seatdata.Status === 'Open') {
                    setblock(false);
                } else if (seatdata && seatdata.Status === 'Blocked') {
                    setrelease(false);
                }
            }
            setSeatForBlockSection(value.toUpperCase());
        } else {
            setSeatForBlockSection('');
            setblock(true);
            // setinoperable(true);
            setrelease(true);
        } 
    }

    const blockSeat = async (blockSeat) => {
        const seatmap = [...st_countOfRowsFormed];
            const row = seatForBlockSection.substring(seatForBlockSection.length - 1, 0);
            const seatrow = seatmap.find(s => s.id == row);
        if (blockSeat) {
            if (seatrow) {
                const seatdata = seatrow.dataToBind.find(d => d.SeatDesignator === seatForBlockSection);
                if (seatdata && seatdata.Status === 'Open') {
                    fncBlockSeat([seatdata.UnitKey])
                    .then((returnVal) => {
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // notify(returnVal.statusText);
                            settriggerModal(true);
                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (!returnVal.data.isError && returnVal.status === 200) {
                                 callSeatMapAndManifest();
                                setSeatForBlockSection('');
                                setblock(true);
                                // setinoperable(true);
                                setrelease(true);
                            } else {
                                console.log('err', returnVal.data);
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                    notify('Something went wrong.');
                                }
                            }
                        }
                    })
                    .catch(e => console.log('err-----',e));
                }
            }
        } else {
            if (seatrow) {
                const seatdata = seatrow.dataToBind.find(d => d.SeatDesignator === seatForBlockSection);
                if (seatdata && seatdata.Status === 'Blocked') {
                    fncUnBlockSeat([seatdata.UnitKey])
                    .then((returnVal) => {
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // notify(returnVal.statusText);
                            settriggerModal(true);
                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (!returnVal.data.isError && returnVal.status === 200) {
                                 callSeatMapAndManifest();
                                setSeatForBlockSection('');
                                setblock(true);
                                // setinoperable(true);
                                setrelease(true);
                            } else {
                                console.log('err', returnVal.data);
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                    notify('Something went wrong.');
                                }
                            }
                        }
                    })
                    .catch(e => console.log('err-----',e));
                }
            }
        }
    }

    const checkPassenger = (pax) => {
        const status = getSegmentsDetail(flightManifest.market, 'liftStatus', pax);
        // console.log('status-====', status);
        if ([1,2].includes(status)) {
            return true;
        } else {
            return false;
        }
    }

    const selectPassengerRow = (i) => {
        if (selectedRow === i) {
            setSelectedRow(-1);
        } else {
            setSelectedRow(i);
        } 
    }

    const classForOpenSeats = (SeatData) => {
        // debugger
        let cls = SeatData.Y == 1 ? "maxseat" : "";
        const preferenceClass = 'seat-preference';
        if ((aisle && SeatData.seatPosition === 'AISLE')
        || (window && SeatData.seatPosition === 'WINDOW')) {
            cls = cls.concat(" ", preferenceClass);
        }
        return cls;
    }

// update

  const handleKeyDown = (e) => {  };

  useEffect(() => {
    const handleKeyDown = (e) => {
        debugger
        if (!passengerList || passengerList.length === 0) return;
        if (e.altKey && e.key.toLowerCase() === 'c') {
            if(shiftUpCount === 2){setdisablelockTable(true)};
                                if(!IsModulAndLoginDivDisabled){
                                    dispatch(moduleAndLoginDivDisabled({
                                        type: "MODULE_AND_LOGINDIV_DISABLED",
                                        IsModulAndLoginDivDisabled: true
                                    }));
                                    setFocusedDiv('right');
                                    fncFocusElementDependsOnPathLocation(location.pathname,seatmanagementsortref.current);
                                }else if (IsModulAndLoginDivDisabled) {
                                    const headingDiv = document.querySelector(".modulebtn");            
                                    if (headingDiv) {                  
                                        headingDiv.focus();
                                        dispatch(moduleAndLoginDivDisabled({
                                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                                IsModulAndLoginDivDisabled: false
                                            }));
                                    }
                                }
            }
            else if (e.shiftKey && e.key === "ArrowRight") {
                console.log(shiftUpCount,"shiftUpCount");
            e.preventDefault();
            if (seatMapTask === 'BLOCKSEAT') {
                setunlockBLOCKSEAT(true);
                setFocusedDiv("right");
                rightSeatsDivRef.current[activeIndex]?.focus();
            } else if ( shiftUpCount === 0) {
                    setleftupdiv(false);
                    setunlockBLOCKSEAT(false);
                    setFocusedDiv("right");
                    setShiftUpCount(2);
                    dispatch(FocusToSubheaderOfSeatmanagementCredential({
                        type: "FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT",
                        isFocusToSubheaderOfSeatmanagement: true
                    }));
                    rightSeatsDivRef.current[activeIndex]?.focus();
                }else if (shiftUpCount === 2){
                    setdisablelockTable(true);
                    setleftupdiv(false);
                    setShiftUpCount(2);
                    setunlockBLOCKSEAT(false);
                    setFocusedDiv("right");
                    rightSeatsDivRef.current[activeIndex]?.focus();
                }
             else if (shiftUpCount === 1) {
                setShiftUpCount(2);
                setFocusedDiv("right");
                rightSeatsDivRef.current[activeIndex]?.focus();
            }
        }
        else if (e.shiftKey && e.key === "ArrowLeft") {
            e.preventDefault();

            if (seatMapTask === 'BLOCKSEAT') {
                setFocusedDiv("");
                dispatch(FocusToSubheaderOfSeatmanagementCredential({
                    type: "FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT",
                    isFocusToSubheaderOfSeatmanagement: true
                }));
                blockinputref.current?.focus();
                setunlockBLOCKSEAT(false);
            } else if (shiftUpCount === 1 || shiftUpCount === 22) {
                setShiftUpCount(2);
                setActiveleftChildIndex(0);
                setFocusedDiv('leftmid');
                allselectref.current?.focus();
            } else if (focusedDiv === 'right') {
                setleftupdiv(false);
                setFocusedDiv("leftmid");
                inputElementForSeat.current[activeleftChildIndex]?.focus();
            }else if (shiftUpCount === 0) {
                setleftupdiv(true);
            setShiftUpCount(1);
            setFocusedDiv("");
            seatmanagementsortref.current?.focus();
            }
            
        } 
        
        else if (e.shiftKey && e.key === "ArrowUp") {
            e.preventDefault();

            if (seatMapTask === 'BLOCKSEAT') {
                setFocusedDiv("");
                setShiftUpCount(0);
                setunlockBLOCKSEAT(true);
                const headingDiv = document.querySelector(".seatManagement-heading-content");
                if (headingDiv) {
                    headingDiv.setAttribute("tabindex", "-1");
                    headingDiv.focus();
                    dispatch(FocusToSubheaderOfSeatmanagementCredential({
                        type: "FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT",
                        isFocusToSubheaderOfSeatmanagement: false
                    }));
                }
            } else if (shiftUpCount === 0) {
                setShiftUpCount(3);
                unAssignref.current?.focus();
            } else if (shiftUpCount === 1) {
                setleftupdiv(false);
                setShiftUpCount(0);
                const headingDiv = document.querySelector(".seatManagement-heading-content");
                if (headingDiv) {
                    headingDiv.setAttribute("tabindex", "-1");
                    headingDiv.focus();
                    dispatch(FocusToSubheaderOfSeatmanagementCredential({
                        type: "FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT",
                        isFocusToSubheaderOfSeatmanagement: false
                    }));
                }
            } else if (shiftUpCount === 2) {
                setdisablelockTable(true);
                setleftupdiv(true);
                setShiftUpCount(1);
                setFocusedDiv("");
                seatmanagementsortref.current?.focus();
            } else if (shiftUpCount === 3) {
                // setdisablelockTable(false);
                setShiftUpCount(2);
                setActiveleftChildIndex(0);
                setFocusedDiv('leftmid');
                // allselectref.current?.focus();
                inputElementForSeat.current[activeleftChildIndex]?.focus();

            }
        } 
        
        else if (e.shiftKey && e.key === "ArrowDown") {
            e.preventDefault();
console.log(shiftUpCount,"shiftUpCount");
            if (seatMapTask !== 'BLOCKSEAT' || shiftUpCount !== 0) {
                if (shiftUpCount === 0) {
                    setleftupdiv(true);
                    setShiftUpCount(1);
                    dispatch(FocusToSubheaderOfSeatmanagementCredential({
                        type: "FOCUS_TO_SUBHEADER_OF_SEATMANAGEMENT",
                        isFocusToSubheaderOfSeatmanagement: true
                    }));
                    setFocusedDiv("");
                    seatmanagementsortref.current?.focus();
                } else if (shiftUpCount === 1) {
                    setdisablelockTable(false);
                    setShiftUpCount(2);
                    setActiveleftChildIndex(0);
                    setFocusedDiv('leftmid');
                    allselectref.current?.focus();
                } else if (unAssign === false && shiftUpCount === 2) {
                    console.log(unAssign,"unasign");
                    setdisablelockTable(true);
                    setShiftUpCount(3);
                    setFocusedDiv('leftdown');
                    unAssignref.current?.focus();
                }
            }
        } 
        else if (e.key === "ArrowUp") {
            if (focusedDiv === "right") {
                setActiveIndex((prevIndex) => {
                    const rows = rightSeatsDivRef.current;
                    let newIndex = prevIndex;
                    while (newIndex > 0) {
                        newIndex--;
                        const prevDiv = rows[newIndex];
                        const checkboxes = Array.from(prevDiv?.querySelectorAll("input[type='checkbox'][status='Open']:not(:disabled)"));
                        if (checkboxes.length > 0) {
                            prevDiv?.focus();
                            return newIndex;
                        }
                    }
                    return prevIndex;
                });
            } else if (focusedDiv === "leftmid") {
                setActiveleftChildIndex((prevIndex) => {
                    const newIndex = Math.max(prevIndex - 1, 0);
                    inputElementForSeat.current[newIndex]?.focus();
                    return newIndex;
                });
            }
        } 
        
        else if (e.key === "ArrowDown") {
            if (focusedDiv === "right") {
                e.preventDefault();
                setActiveIndex((prevIndex) => {
                    const rows = rightSeatsDivRef.current;
                    let newIndex = prevIndex;
                    while (newIndex < rows.length - 1) {
                        newIndex++;
                        const nextDiv = rows[newIndex];
                        const checkboxes = Array.from(nextDiv?.querySelectorAll("input[type='checkbox'][status='Open']:not(:disabled)"));
                        if (checkboxes.length > 0) {
                            nextDiv?.focus();
                            return newIndex;
                        }
                    }
                    return prevIndex;
                });
            } else if (focusedDiv === "leftmid") {
                e.preventDefault();
                setActiveleftChildIndex((prevIndex) => {
                    const rows = inputElementForSeat.current;
                    const newIndex = Math.min(prevIndex + 1, rows.length - 1);
                    inputElementForSeat.current[newIndex]?.focus();
                    return newIndex;
                });
            }
        }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
}, [passengerList, focusedDiv, seatMapTask, unlockBLOCKSEAT, activeIndex, shiftUpCount, activeleftChildIndex, IsModulAndLoginDivDisabled,unAssign]);


useEffect(() => {
        if ( rightSeatsDivRef.current[activeIndex]) {
          rightSeatsDivRef.current[activeIndex].focus();}
     },[activeIndex]);

    useEffect(() => {
        if ( inputElementForSeat.current[activeleftChildIndex]) {
               inputElementForSeat.current[activeleftChildIndex].focus();}
     },[activeleftChildIndex]);
    
     const trapFocus4 = (e, divIndex, ref) => {
        const currentDiv = ref.current[divIndex];
        if (!currentDiv) return;
        const checkbox = currentDiv.querySelector(
          "input[type='checkbox'],[tabindex]:not([tabindex='-1'])"
        );
      
        if (!checkbox) return;
              if (e.key === "Tab") {
          e.preventDefault();
          checkbox.focus();
        }
      };
      
      const trapFocus3 = (e, divIndex, ref) => {
        const currentDiv = ref.current[divIndex];
        if (!currentDiv) return;
      
        // Select only focusable elements where checkboxes have status="open"
        const focusableElements = Array.from(
          currentDiv.querySelectorAll(
            "input[status='open'], [tabindex]:not([tabindex='-1'])"
          )
        );    
        if (focusableElements.length === 0) return; // No valid focusable elements, do nothing
      
        const currentIndex = focusableElements.indexOf(document.activeElement);
      
        if (e.key === "Tab") {
          if (e.shiftKey) {
            // Shift+Tab: Move focus backward
            if (currentIndex > 0) {
              e.preventDefault();
              focusableElements[currentIndex - 1].focus();
            } else {
              // If it's the first element, wrap to the last element
              e.preventDefault();
              focusableElements[focusableElements.length - 1].focus();
            }
          } else {
            // Tab: Move focus forward
            if (currentIndex < focusableElements.length - 1) {
              e.preventDefault();
              focusableElements[currentIndex + 1].focus();
            } else {
              // If it's the last element, wrap to the first element
              e.preventDefault();
              focusableElements[0].focus();
            }
          }
        }
      }; 
  
    useEffect(() => {
        if (showPaxNotSelectedError) {
            (PaxNotSelected.current)
            PaxNotSelected.current.focus();
        }
}, [showPaxNotSelectedError]);
    useEffect(() => {
        if (showSSRSeatNotAvailableErrorPopup) {
            (okbutton.current)
            okbutton.current.focus();
        }
}, [showSSRSeatNotAvailableErrorPopup]);
    useEffect(() => {
        if (showErrorPopup) {
            (okbutton1.current)
            okbutton1.current.focus();
        }
}, [showErrorPopup]);

    const checkAisleSeat = (pax, selectedRow) => {
        // console.log('pax', pax, selectedRow);
        const seatNo = getSegmentsDetail(flightManifest.market, 'seat', pax);
        
        if (seatNo !== '') {
            const seatmap = [...st_countOfRowsFormed];
            // const { passengerKey, recordLocator } = selectedpax;
            const row = seatNo.substring(seatNo.length - 1, 0);
            const seatrow = seatmap.find(s => s.id == row)
            const data = seatrow.dataToBind.find(d => d.SeatDesignator === seatNo);
            if (data.seatPosition === 'AISLE') {
                return true;
            }
        }
         else {
            return false;
        }
    }

    const checkWindowSeat = (pax, selectedRow) => {
        // console.log('pax', pax, selectedRow);
        const seatNo = getSegmentsDetail(flightManifest.market, 'seat', pax);
        
        if (seatNo !== '') {
            const seatmap = [...st_countOfRowsFormed];
            // const { passengerKey, recordLocator } = selectedpax;
            const row = seatNo.substring(seatNo.length - 1, 0);
            const seatrow = seatmap.find(s => s.id == row)
            const data = seatrow.dataToBind.find(d => d.SeatDesignator === seatNo);
            if (data.seatPosition === 'WINDOW') {
                return true;
            }
        }
         else {
            return false;
        }
    }

    const getSeatIconForSelectedPax = (pax, selectedRow) => {
        // console.log('pax', pax, selectedRow);
        const seatNo = getSegmentsDetail(flightManifest.market, 'seat', pax);
        
        if (seatNo !== '') {
            const seatmap = [...st_countOfRowsFormed];
            // const { passengerKey, recordLocator } = selectedpax;
            const row = seatNo.substring(seatNo.length - 1, 0);
            const seatrow = seatmap.find(s => s.id == row)
            const data = seatrow.dataToBind.find(d => d.SeatDesignator === seatNo);
            if (data.Y === 1) {
                return 'newImages/seat-max.svg';
            } else {
                return 'newImages/seat-normal.svg'
            }
        }
         else {
            return '';
        }
    }

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <Modal
                show={showErrorPopup}
                onHide={handleCloseshowErrorPopup}
                backdrop="static"
                keyboard={false}
                className="clsQuickAssign"
            >
                <Modal.Header
                //  closeButton
                 >
                <Modal.Title>Seat Assignment Failed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                The time limit for seat assignment has been exceeded.
                </Modal.Body>
                <Modal.Footer>
                <button tabIndex={1} ref={okbutton1} className=" focusClass btn btn-red OrangeShadow" onClick={handleCloseshowErrorPopup}>
                    OK
                </button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showSSRSeatNotAvailableErrorPopup}
                onHide={handleSSRSeatNotAvailableErrorPopup}
                backdrop="static"
                keyboard={false}
                className="clsQuickAssign"
            >
                <Modal.Header 
                // closeButton
                >
                <Modal.Title>Seat Assignment Failed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                Cannot select this seat because an infant/wheelchair/UNMR passenger is already there in the same row.
                </Modal.Body>
                <Modal.Footer>
                <button ref={okbutton} className="btn btn-red" onClick={handleSSRSeatNotAvailableErrorPopup}>
                    OK
                </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showPaxNotSelectedError}
                onHide={handleshowPaxNotSelectedError}
                backdrop="static"
                keyboard={false}
                className="clsQuickAssign"
            >
                <Modal.Header
                //  closeButton
                >
                <Modal.Title>Seat Assignment Failed</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                Please select a passenger to assign the seat.
                </Modal.Body>
                <Modal.Footer>
                <button  ref={PaxNotSelected} className="btn btn-red OrangeShadow" onClick={handleshowPaxNotSelectedError}>
                    OK
                </button>
                </Modal.Footer>
            </Modal>
            <div class="full-container">
                <div class="seat-container boardingSeat-container">
                    <div class="row">
                        {
                            seatMapTask === 'BLOCKSEAT' ?
                            <div class="col-lg-8">
                                <div class="leftDetail-data">
                                    <FocusLock disabled={unlockBLOCKSEAT}>
                                    <div class="pTable-data-outer">
                                        <div class="heading">
                                            <h4 class="font-xxl bold dark-text mb-0">
                                                Seat Management <span class="font-md regular">[Block Seat(s)]</span>
                                            </h4>
                                        </div>
                                        <div class="mt-4 row">
                                            <div class="form-group col-lg-2 col-sm-3 col-4">
                                                <label class="font-sm mb-2">
                                                    Seat
                                                </label>
                                                <input type="text" ref={blockinputref} value={seatForBlockSection} onChange={(e) => { fncEnterSeatToBlock(e) }}  class="form-control text-center mw-100"/>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-4">
                                            <button class="btn btn-primary me-3 SerachBtn" onClick={() => { blockSeat(true) }} disabled={block}>
                                                <span class="px-3">Block</span>
                                            </button>
                                            {/* <button class="btn btn-outline-primary me-3" disabled={inoperable}>
                                                <span class="px-3">Inoperable</span>
                                            </button> */}
                                            <button class="btn btn-primary SerachBtn" disabled={release} onClick={() => { blockSeat(false) }}>
                                                <span class="px-3">Release</span>
                                            </button>
                                        </div>
                                    </div>
                                    </FocusLock>
                                </div>
                            </div>
                            : seatMapTask === 'ASSIGNSEAT'
                            ?
                            <div class="col-lg-8">
                                <div class="leftDetail-data">
                                    <div class="pTable-data-outer">
                                    <FocusLock disabled={shiftUpCount === 0 || shiftUpCount === 2 || shiftUpCount === 3}>
                                    <div class="heading focusClass OrangeShadow"  tabIndex={-1} ref={seatmanagementsortref} >
                                            <h4 class="font-xxl bold dark-text mb-0">
                                                Seat Management <span class="font-md regular">(Assignments)</span>
                                            </h4>
                                            <div class="right-actions">
                                                <div class="d-flex justify-content-between align-items-center btn-contain" >
                                                    <div class="dropdown menu-btn filterDropdown focusClass OrangeShadow">
                                                        <button 
                                                        //    ref={seatmanagementsortref}
class="filter-button dropdown-toggle btn focusClass OrangeShadow checkbox-input btn-prim" data-bs-toggle="dropdown" aria-expanded="false" type="button" id="filter" >

                                                            <img src="newImages/filter-icon.svg" alt="filter-icon" />
                                                        </button>
                                                        <div class="dropdown-menu dropdown-menu-end customScroll " aria-labelledby="filter" 
                                                          onClick={(e) => e.stopPropagation()}
                                                          >
<FocusLock>
                                                            <div class="filter-content">
                                                                <div class="row">
                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" name="checkedStandBy" type="checkbox" checked={checkedStandBy} onChange={(e) => { fncAddFilter(e, 'checkedStandBy') }} id="checkedStandBy" />
                                                                            <label class="form-check-label font-md" for="checkedStandBy">
                                                                                Checked stand-by
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" name="totalCheckedIn" checked={totalcheckedIn} onChange={(e) => { fncAddFilter(e, 'totalcheckedIn') }} type="checkbox" id="totalCheckedIn" />
                                                                            <label class="form-check-label font-md" for="totalCheckedIn">
                                                                                Total checked in
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" name="Boarded" checked={boarded} onChange={(e) => { fncAddFilter(e, 'boarded') }} type="checkbox" id="Boarded" />
                                                                            <label class="form-check-label font-md" for="Boarded">
                                                                                Boarded
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" name="allCheckedInWithoutSeat" checked={allCheckedInWithoutSeat} onChange={(e) => { fncAddFilter(e, 'allCheckedInWithoutSeat') }} type="checkbox" id="allCheckedInWithoutSeat" />
                                                                            <label class="form-check-label font-md" for="allCheckedInWithoutSeat">
                                                                                All checked in without seat
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" checked={noseat} onChange={(e) => { fncAddFilter(e, 'noseat') }} name="noSeats" type="checkbox" id="noSeats" />
                                                                            <label class="form-check-label font-md" for=" noSeats">
                                                                                No seats
                                                                    </label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-sm-6 mb-3">
                                                                        <div class="font-lg">
                                                                            <input class="form-check-input me-2 focusClass" checked={withExtraSeat} onChange={(e) => { fncAddFilter(e, 'withExtraSeat') }} name="withExtraSeat" type="checkbox" id="withExtraSeat" />
                                                                            <label class="form-check-label font-md" for="withExtraSeat">
                                                                                With extra seat
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <div class="row">
                                                                    <div class="col-sm-6 mb-4">
                                                                        <div class="form-floating ">
                                                                            <input type="text" class="form-control focusClass" id="name" value={filterName} onChange={(e) => { fncFilterByName(e) }} placeholder="Name" />
                                                                            <label for="name">Name</label>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-6 mb-4">
                                                                        <div class="form-floating ">
                                                                            <input type="text" class="form-control focusClass" id="recLocator" value={recordlocator} onChange={(e) => { fncFilterByRecordLocator(e) }} placeholder="Rec Locator" />
                                                                            <label for="recLocator">Rec Locator</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="buttons d-flex align-items-center">
                                                                    <button class="btn btn-primary me-4 SerachBtn" onClick={() => { fncfilterByChecked();  
                                                                    const dropdownMenu = document.getElementById('filter');
                                                                    if (dropdownMenu) {
                                                                    dropdownMenu.click();
                                                                    } }} ><span class="px-4">GO</span></button>
                                                                    <button class="btn btn-primary SerachBtn"><span class="px-3" onClick={() => { fncClearAllFilters() }}>Clear</span></button>
                                                                </div>
                                                            </div>
                                                            </FocusLock>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </FocusLock>
                                        <FocusLock disabled={disablelockTable}>
                                        <div class="searchTable OrangeShadow">
                                            <table class="seatTable">
                                                <thead>
                                                    <tr>
                                                        {
                                                            passengerList && passengerList.length ?
                                                            <th class="checkbox">
                                                                <input ref={allselectref} class="me-2 form-check-input focusClass OrangeShadow" type="checkbox" checked={selectAllPassengers} onChange={(e) => { fncSelectAllPassengers(e)}} id="selectAll" name="selectAll" />
                                                            </th> : null
                                                        }
                                                        <th colSpan="4">Sort By Last Name</th>
                                                        <th class="input">{flightManifest.market.destination} (1)</th>
                                                    </tr>
                                                </thead>
                                                {
                                                    passengerList && passengerList.length ? passengerList.map((pax, i) =>
                                                        <tbody key={i}>
                                                            <tr  class="checkbox-input"
                                                            key={i} 
                                                             ref={(el) => (inputElementForSeat.current[i] = el)}
                                                             tabIndex={-1} 
                                                            onKeyDown={(e) => {                                                              
                                                                  handleKeyDown(e); 
                                                                   if (activeleftChildIndex === i) { 
                                                                      trapFocus4(e, i,inputElementForSeat);
                                                                        }   
                                                                  }  }                                                             
                                                         style={(selectedRow) === i ? {'backgroundColor': '#F6C1B1'}:{'': ''}}
                                                          onClick={() => selectPassengerRow(i)}>
                                                                <td class="checkbox">
                                                                    <input class="me-2 form-check-input focusClass" type="checkbox" checked={pax.isSelectedForSeatAssign} onChange={(e) => { fncSelectPassenger(e, pax)}} id="1" name="1" />
                                                                    <label for="1" class="font-md grey-text mb-0">{pax.recordLocatorCount}</label></td>
                                                                <td class="icon">
                                                                    <img src={getIconForPassenger(pax, flightManifest)} alt="icon" />
                                                                </td>
                                                                <td class="name">{`${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}`}</td>
                                                                <td class="service">{getSegmentsDetail(flightManifest.market, 'ssrs', pax)} </td>
                                                                <td class="input"><input type="text" readOnly={checkPassenger(pax)}  value={getSegmentsDetail(flightManifest.market, 'seat', pax)} class="form-control" /></td>
                                                            
                                                            </tr>
                                                        </tbody>
                                                    ) : <tr className="noresultErrormessageForSeat">No result found. Please refine your search terms</tr>
                                                }
                                            </table>
                                        </div>
                                        </FocusLock>
                                    </div>
                                    <div class="btn-container OrangeShadow" tabIndex={-1}>
                                        {/* <button class="btn btn-outline-primary pt-2" onClick={() => { printBoardingPass() }} disabled={printBP}>
                                            <span class="px-3">Print B.Pass</span>
                                        </button> */}
                                        <div class="d-flex  pt-2 OrangeShadow"  >
                                            {/* <button class="btn btn-outline-primary me-3" onClick={() => { autoAssignSeat() }} disabled={autoAssign}>
                                                <span class="px-3"> Auto-Assign</span>
                                            </button> */}
                                            <button class="btn btn-primary SerachBtn " ref={unAssignref} onClick={() => { unAssignSeat() }} 
                                                    disabled={unAssign}>
                                                <span class="px-3"> Un-Assign</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                        
                        <div class="col-lg-4 d-none d-lg-block">
                            <div class="rightDetail-data ">
                                <h4 class="fixedHeading font-md bold dark-text">Seat Map | <span class="ps-2">1</span></h4>
                                <ol class={st_countOfRowsFormed.length > 0 && st_countOfRowsFormed[0].dataToBind.length === 4 ? "cabin fuselage seat2-2" : "cabin fuselage"}>
                                    <li class="row row--1 marks">
                                        <ol class="seats" type="A">
                                            <li></li>
                                            {st_AirlineHeader.length == 0 ? '' :
                                                st_AirlineHeader.map((data, i) =>
                                                    <li class="seat">
                                                        {<p>{data.SeatDesignator}</p>}
                                                    </li>
                                                )}
                                        </ol>
                                    </li>
                                    {
                                        st_countOfRowsFormed.length == 0 ? '' :
                                            st_countOfRowsFormed.map((data, i) =>
                                                <li class={`row row--${data.id} checkbox-input`} id={`seatRow-${data.id}`} 
                                            key={data.id}
                                            ref={(el) => (rightSeatsDivRef.current[i] = el)}
                                            tabIndex={-1} 
                                                 onKeyDown={(e) => {
                                              handleKeyDown(e, data.id,"seatRows"); 
                                             if (activeIndex === i) {
                                                trapFocus3(e, i,rightSeatsDivRef); 
                                             }
                                     }}
                                      style={{
                                       outline: activeIndex === i ? "2px #f0f8ff" : "none",
                                       backgroundColor: activeIndex === i? "#f0f8ff" : "#ffffff",
                                       }}
                                        >
                                                    <ol class="seats" type="A">
                                                        <li>{data.id}.</li>
                                                        {
                                                            data.dataToBind.map((SeatData, j) =>
                                                                <li class="seat" y={SeatData.Y}   
                                                                  tabIndex={-1}
                                                                    >
                                                                    {
                                                                        SeatData.Status == "Open" ?
                                                                            <div 
                                                                                    tabIndex={-1}                        
                                                                      >
                                                                                <input
                                                                                     tabIndex={-1}                        
                                                                               class={classForOpenSeats(SeatData)} status={SeatData.Status} type="checkbox" />
                                                                                <label
                                                                                     onClick={() => { fncSeatSelection(SeatData, "SEATMAP", data.id) }}
                                                                                     tabIndex={0} 
                                                                                 onKeyUp={(e) => {
                                                                                    // e.stopPropagation();
                                                                                    // handleKeyDown(e);
                                                                                     if (e.key === "Enter") {
                                                                                    //    e.stopPropagation();
                                                                                      fncSeatSelection(SeatData, "SEATMAP", data.id); 
                                                                                    }
                                                                                  }}
                                                                                 >{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                                            </div>
                                                                            :
                                                                            SeatData.Status == "Blocked" || SeatData.Status == "Unavailable" ?
                                                                            <div>
                                                                            <input
                                                                              type="text"
                                                                              className={SeatData.Y === 1 ? "maxseat blocked" : "blocked"}
                                                                              value={SeatData.SeatDesignator || ''}
                                                                              onChange={(e) => handleSeatInputChange(e, SeatData, data.id)}
                                                                              readOnly={seatMapTask !== 'BLOCKSEAT'} // Optional: make it readonly unless in BLOCKSEAT mode
                                                                            />
                                                                            <label
                                                                              onClick={() => {
                                                                                if (seatMapTask === 'BLOCKSEAT') {
                                                                                  fncSeatSelection(SeatData, "SEATMAP", data.id);
                                                                                }
                                                                              }}
                                                                            >
                                                                              {SeatData.SeatDesignator || ""}
                                                                            </label>
                                                                          </div>
                                                                          
                                                                                :
                                                                                SeatData.Status == "Broken" ?
                                                                                    <div>
                                                                                        <input class={SeatData.Y == 1 ? "maxseat borkenSeat" : "borkenSeat"} type="checkbox" />
                                                                                        <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                                                    </div>
                                                                                    :
                                                                                    SeatData.Status == "CheckedIn" ?
                                                                                        <div>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                class={classForCheckedIn(SeatData)}
                                                                                            />
                                                                                            <label>{SeatData.SeatDesignator ? SeatData.SeatDesignator : ""}</label>
                                                                                        </div>
                                                                                        :
                                                                                        SeatData.Status == "Reserved" ?
                                                                                            <div>
                                                                                                {ssrsOnOtherSeats(SeatData)}
                                                                                            </div>
                                                                                            : SeatData.Status == "HeldForAnotherSession" ?
                                                                                                <div> {ssrsOnOtherSeats(SeatData)} </div>
                                                                                                : SeatData.Status == "0" ?
                                                                                                    ""
                                                                                                    :
                                                                                                    ""

                                                                    }
                                                                </li>
                                                            )
                                                        }
                                                    </ol>
                                                </li>
                                            )
                                    }
                                </ol>
                                <div class="seatFooter">
                                    <div class="border-bottom mb-3"></div>
                                    <div class="d-flex align-items-center justify-content-between mb-2">
                                        <h4 class="font-md bold dark-text title mb-0">Details 
                                            <span class="ps-2">
                                                {
                                                    selectedRow !== -1 
                                                    ? getSegmentsDetail(flightManifest.market, 'seat', passengerList[selectedRow])
                                                    : '-'
                                                }
                                            </span>
                                        </h4>
                                        {
                                            selectedRow !== -1 ?
                                            (
                                                checkAisleSeat(passengerList[selectedRow], selectedRow) ?
                                            <div class="seatMap-item d-flex align-items-center" >
                                                <div class="seat-icon me-2">
                                                    <img class="icon-20" src="newImages/aisle-seat.svg" />
                                                </div>
                                                <p class="font-md mb-0">Aisle</p>
                                            </div> : ''
                                            ) : ''
                                        }
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="seatMap-item d-flex align-items-center">
                                            {
                                                selectedRow !== -1 ?
                                                (
                                                    <div class="seat-icon me-2">
                                                        <img class="icon-20" src={getSeatIconForSelectedPax(passengerList[selectedRow], selectedRow)} />
                                                        {/* "newImages/seat-max.svg" */}
                                                        
                                                    </div>
                                                ) : ''
                                            }
                                            {
                                                selectedRow !== -1 ? 
                                                <p class="font-md mb-0">
                                                    {getSeatIconForSelectedPax(passengerList[selectedRow], selectedRow) === "newImages/seat-max.svg" ?
                                                    'Spice Max' : 'Normal'
                                                    }
                                                </p> : ''
                                            }
                                            
                                        </div>
                                        {
                                            selectedRow !== -1 ?
                                            (
                                                checkWindowSeat(passengerList[selectedRow], selectedRow) ?
                                                <div class="seatMap-item d-flex align-items-center">
                                                    <div class="seat-icon me-2">
                                                        <img class="icon-20" src="newImages/window-seat.svg" />
                                                    </div>
                                                    <p class="font-md mb-0">Window</p>
                                                </div> : ''
                                            ) : ''
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default SeatManagement;